"use strict";
var m = require('./mathTimo');
var f = require('./fileTimo');
var fs = require('fs');
var d = require('./numberMethods');

function segment(page, segment, width, color) {
    var h = page.length / width
    if (segment < 3) {
        for (var x = 2; x < width - 1; x++) {
            page[x + (12 * segment + 2) * width] = color
            page[x + (12 * segment + 3) * width] = color
            page[x + (12 * segment + 4) * width] = color
            page[x + (12 * segment + 5) * width] = color
            page[x + (12 * segment + 6) * width] = color
        }
    } else {
        for (var y = 1; y < (h / 2) - 1; y++) {
            var xx = 2
            if (segment == 4 || segment == 6) xx = width - 4;
            var yy = 2
            if (segment == 5 || segment == 6) yy = (h / 2 | 0) - 4
            page[xx + 0 + (y + yy) * width] = color
            page[xx + 1 + (y + yy) * width] = color
            page[xx + 2 + (y + yy) * width] = color
        }
    }
}
function createSimulatedNumber(number, width) {
    var color = 0;
    var backGround = 255;
    if (number < 0) {
        color = 255;
        backGround = 0
        number = -number
    }
    var page = []
    var h = 35
    for (var i = 0; i < width * h; i++)page[i] = backGround;
    if (number == 0) {
        segment(page, 0, width, color)
        segment(page, 3, width, color)
        segment(page, 4, width, color)
        segment(page, 5, width, color)
        segment(page, 6, width, color)
        segment(page, 2, width, color)
    }

    if (number == 1) {
        segment(page, 4, width, color)
        segment(page, 6, width, color)
    }

    if (number == 2) {
        segment(page, 0, width, color)
        segment(page, 4, width, color)
        segment(page, 1, width, color)
        segment(page, 5, width, color)
        segment(page, 2, width, color)
    }

    if (number == 3) {
        segment(page, 0, width, color)
        segment(page, 1, width, color)
        segment(page, 2, width, color)
        segment(page, 4, width, color)
        segment(page, 6, width, color)
    }

    if (number == 4) {
        segment(page, 3, width, color)
        segment(page, 4, width, color)
        segment(page, 1, width, color)
        segment(page, 6, width, color)
    }

    if (number == 5) {
        segment(page, 0, width, color)
        segment(page, 3, width, color)
        segment(page, 1, width, color)
        segment(page, 6, width, color)
        segment(page, 2, width, color)
    }

    if (number == 6) {
        segment(page, 0, width, color)
        segment(page, 3, width, color)
        segment(page, 1, width, color)
        segment(page, 5, width, color)
        segment(page, 6, width, color)
        segment(page, 2, width, color)
    }

    if (number == 7) {
        segment(page, 0, width, color)
        segment(page, 4, width, color)
        segment(page, 6, width, color)
    }

    if (number == 8) {
        segment(page, 0, width, color)
        segment(page, 1, width, color)
        segment(page, 2, width, color)
        segment(page, 3, width, color)
        segment(page, 4, width, color)
        segment(page, 5, width, color)
        segment(page, 6, width, color)
    }

    if (number == 9) {
        segment(page, 0, width, color)
        segment(page, 3, width, color)
        segment(page, 4, width, color)
        segment(page, 1, width, color)
        segment(page, 6, width, color)
        segment(page, 2, width, color)
    }
    return page;
}
function corner(x, y) {
    var corner = 1;
    var xx = x - n.number.x
    var yy = y - n.number.y
    if (yy > numberHeight / 2) corner += 2;
    if (xx > numberWidth / 2) corner += 1
    return corner;
}
function horisontalHalf(x, y) {
    var half = 1;
    y = y - n.number.y
    if (y > numberHeight / 2) half += 1;
    return half;

}
function horisontalMidSection(x, y) {
    x = x - n.number.x
    y = y - n.number.y
    if (y < numberHeight / 4) return 0
    if (y > numberHeight * 3 / 4) return 0
    if (x < numberWidth / 2) return 1
    return 2

}
function verticalMidSection(x, y) {
    x = x - n.number.x
    y = y - n.number.y
    if (x < numberWidth / 4) return 0
    if (x > numberWidth * 3 / 4) return 0
    if (y < numberHeight / 2) return 1
    return 2
}
function center(x, y) {
    x = x - n.number.x
    y = y - n.number.y
    if (x < numberWidth / 4) return 0
    if (x > numberWidth * 3 / 4) return 0
    if (y < numberHeight / 4) return 0
    if (y > numberHeight * 3 / 4) return 0
    return 1
}
var minZeroHoleSizeRatio = 0.14
var ruleOneLargeHoleInCenter = function () {
    if (n.holes.length == 0) return false;
    if (n.holes.length > 1 && n.holes[1].size > smallestValidHoleSize) return false;
    if (center(n.holes[0].xG, n.holes[0].yG) == 0) return false;
    if (n.holes[0].size < minZeroHoleSizeRatio * nBoxSize) return false;
    return true;
}
var ruleOneLargeHoleInCenterFor4WithHole = function () {
    if (n.holes.length == 0) return false;
    if (n.holes.length > 1 && n.holes[1].size > smallestValidHoleSize) return false;
    if (center(n.holes[0].xG, n.holes[0].yG + (numberHeight - n.leftRadar.bottomIndex) * 0.5) == 0) return false;
    if (n.holes[0].size < minZeroHoleSizeRatio * nBoxSize) return false;
    return true;
}
var ruleOneHoleInTightCenter = function () {
    if (n.holes.length == 0) return false;
    if (n.holes.length > 1 && n.holes[1].size > smallestValidHoleSize) return false;
    if (center(n.holes[0].xG, n.holes[0].yG) == 0) return false;
    return true;
}
var holeOvalityLimit = 185
var ruleHoleIsRoundFor4 = function () {
    if (n.holes.length == 0) return false;
    if (n.holes.length > 1 && n.holes[1].size > smallestValidHoleSize) return false;
    if (n.holes[0].ovality > holeOvalityLimit * 0.65) return false
    return true;
}
var smallestValidHoleSize = 4
var ruleHoleIsRoundFor6 = function () {
    if (nBoxSize == 0) return false;
    var relativeNumberHeightToWidthRatio = 0.67 * numberHeight / numberWidth
    if (relativeNumberHeightToWidthRatio < 1) relativeNumberHeightToWidthRatio = 1 / relativeNumberHeightToWidthRatio
    if (n.holes.length == 0) return false;
    if (n.holes.length > 1 && n.holes[1].size > smallestValidHoleSize) return false;
    if (n.holes[0].ovality > holeOvalityLimit * relativeNumberHeightToWidthRatio) return false
    return true;
}
var ruleTopHoleIsRound = function () {
    if (nBoxSize == 0) return false;
    var relativeNumberHeightToWidthRatio = 0.67 * numberHeight / numberWidth
    if (relativeNumberHeightToWidthRatio < 1) relativeNumberHeightToWidthRatio = 1 / relativeNumberHeightToWidthRatio
    if (n.holes.length < 1) return false;
    else if (n.holes.length < 2) { if (n.holes[0].ovality > holeOvalityLimit * relativeNumberHeightToWidthRatio) return false }
    else {
        if (n.holes[0].yG < n.holes[1].yG) { if (n.holes[0].ovality > holeOvalityLimit * relativeNumberHeightToWidthRatio) return false }
        else { if (n.holes[1].ovality > holeOvalityLimit * relativeNumberHeightToWidthRatio) return false }
    }
    return true;
}
var holeOvalityLimitFor8WithBottomDip = 160
var ruleTopHoleIsRoundFor8WithBottomDip = function () {
    if (nBoxSize == 0) return false;
    var relativeNumberHeightToWidthRatio = 0.67 * numberHeight / numberWidth
    if (relativeNumberHeightToWidthRatio < 1) relativeNumberHeightToWidthRatio = 1 / relativeNumberHeightToWidthRatio
    if (n.holes.length < 1) return false;
    else if (n.holes.length < 2) { if (n.holes[0].ovality > holeOvalityLimitFor8WithBottomDip * relativeNumberHeightToWidthRatio) return false }
    else {
        if (n.holes[0].yG < n.holes[1].yG) { if (n.holes[0].ovality > holeOvalityLimitFor8WithBottomDip * relativeNumberHeightToWidthRatio) return false }
        else { if (n.holes[1].ovality > holeOvalityLimitFor8WithBottomDip * relativeNumberHeightToWidthRatio) return false }
    }
    return true;
}
var ruleBottomHoleIsRoundFor8WithTopDip = function () {
    if (nBoxSize == 0) return false;
    var relativeNumberHeightToWidthRatio = 0.67 * numberHeight / numberWidth
    if (relativeNumberHeightToWidthRatio < 1) relativeNumberHeightToWidthRatio = 1 / relativeNumberHeightToWidthRatio
    if (n.holes.length < 1) return false;
    if (n.holes[0].ovality > holeOvalityLimitFor8WithBottomDip * relativeNumberHeightToWidthRatio) return false
    return true;
}
var ruleBottomHoleIsRound = function () {
    if (nBoxSize == 0) return false;
    var relativeNumberHeightToWidthRatio = 0.67 * numberHeight / numberWidth
    if (relativeNumberHeightToWidthRatio < 1) relativeNumberHeightToWidthRatio = 1 / relativeNumberHeightToWidthRatio
    if (n.holes.length < 2) return false;
    if (n.holes[1].yG < n.holes[0].yG) { if (n.holes[0].ovality > holeOvalityLimit * relativeNumberHeightToWidthRatio) return false }
    else { if (n.holes[1].ovality > holeOvalityLimit * relativeNumberHeightToWidthRatio) return false }
    return true;
}
var numberTopBottomRatioLimitFor8 = 1.80
var ruleNumberIsBottomHeavyForEight = function () {
    if (n.number.topBottomRatio > numberTopBottomRatioLimitFor8) return false;
    return true;
}
var holeSizeToHeightRatioLimit = 15
var ruleHoleIsBigComparedToHeight = function () {
    if (n.holes.length != 1) return false;
    if ((n.holes[0].size / n.holes[0].height) < holeSizeToHeightRatioLimit) return false
    return true;
}


var numberWidthHeightRatio = 0.5
var ruleNumberWidthIsSmallComparedToHeight = function () {
    if (numberWidth / numberHeight > numberWidthHeightRatio) return false;
    return true;
}
var numberMaxWidthToHeightRatioLimit = 0.9
var ruleNumberIsNotTooWideComparedToHeight = function () {
    if (numberWidth > numberMaxWidthToHeightRatioLimit * numberHeight) return false;
    return true;
}
var ruleNumberIsNotTooWideComparedToHeightFor7Wide = function () {
    if (numberWidth > numberMaxWidthToHeightRatioLimit * numberHeight * 1.1) return false;
    return true;
}
var numberWidthMinimumRatioFor1 = 0.34
var ruleNumberIsTooNarrowFor1 = function () {
    if (numberWidth > conf.numberMaxWidth * numberWidthMinimumRatioFor1) return false;
    return true;
}
var numberWidthMinimumRatio = 0.40
var ruleNumberIsTooNarrow = function () {
    if (numberWidth > conf.numberMaxWidth * numberWidthMinimumRatio) return false;
    return true;
}
var numberSizeMinimumRatio = 0.22
var ruleNumberSizeIsTooSmall = function () {
    var numberSize = conf.numberMaxHeight * conf.numberMaxWidth
    if (n.number.size > numberSize * numberSizeMinimumRatio) return false;
    return true;
}
var ruleNumberOneSizeIsTooSmall = function () {
    if (n.number.size > conf.numberMaxHeight * conf.numberMaxWidth * numberSizeMinimumRatio) return false;
    return true;
}
var ruleNumberOneSizeIsTooSmallForPlainOne = function () {
    if (n.number.size > conf.numberMaxHeight * conf.numberMaxWidth * numberSizeMinimumRatio * 0.8) return false;
    return true;
}
var largeSideDipSizeLimit = 0.02

var number3midLeftBulgeSizeLimit = 0.01
var ruleLargeLeftDipRightSideDip = function () {
    if (nBoxSize == 0) return false;
    if (n.leftDipRightSideDip.size < number3midLeftBulgeSizeLimit * nBoxSize) return false;
    return true;
}
var ruleLargeLeftDipRightSideDipFor3Narrow = function () {
    if (nBoxSize == 0) return false;
    if (n.leftDipRightSideDip.size * 0.66 < numberWidth * numberWidth * number3midLeftBulgeSizeLimit) return false;
    return true;
}
var ruleLargeLeftDipInMid = function () {
    //    var numberSize = numberBoxSize(n)
    if (n.leftDip.size < nBoxSize * largeSideDipSizeLimit) return false;
    if (horisontalMidSection(n.leftDip.xG, n.leftDip.yG) == 0) return false;
    return true;
}
var ruleLargeRightDip = function () {
    //    var numberSize = numberBoxSize(n)
    if (n.rightDip.size / nBoxSize < largeSideDipSizeLimit) return false;
    return true;
}
var rightDipFor3WidthLimitRatio = 0.25
var rightDipFor3HeightLimitRatio = 0.35
var rightDipFor3CenterHeightLimitRatio = 0.3
var ruleMaxSmallRightDipInTheMiddle = function () {
    if (n.rightDip.size == 0) return true;
    if (n.rightDip.size > nBoxSize * largeSideDipSizeLimit * 2) return false;
    if (n.rightDip.height > rightDipFor3HeightLimitRatio * numberHeight) return false;
    if (n.rightDip.yG < rightDipFor3CenterHeightLimitRatio * numberHeight * 0.5) return false;
    if (n.rightDip.yG > (1 - rightDipFor3CenterHeightLimitRatio) * numberHeight) return false;
    if (n.rightDip.width > rightDipFor3WidthLimitRatio * numberWidth) return false;
    return true;
}
var ruleLargeRightTopDip = function () {
    //    var numberSize = numberBoxSize(n)
    if (n.rightTopDip.size / nBoxSize < largeSideDipSizeLimit * 0.5) return false;
    return true;
}
var ruleLargeRightBottomDip = function () {
    //    var numberSize = numberBoxSize(n)
    if (n.rightBottomDip.size < nBoxSize * largeSideDipSizeLimit * 0.5) return false;
    return true;
}
var smallSideDipSizeLimit = 0.01
var ruleSmallRightDip = function () {
    //    var numberSize = numberBoxSize(n)
    if (n.rightDip.size < nBoxSize * smallSideDipSizeLimit) return false;
    return true;
}
var smallRoofDipSizeLimit = 0.01
var ruleSmallRoofDip = function () {
    //    var numberSize = numberBoxSize(n)
    if (n.roofDip.size < nBoxSize * smallRoofDipSizeLimit) return false;
    return true;
}
var ruleLargeLeftDip = function () {
    //    var numberSize = numberBoxSize(n)
    if (n.leftDip.size < nBoxSize * largeSideDipSizeLimit) return false;
    return true;
}
var ruleSmallLeftBottomDip = function () {
    //    var numberSize = numberBoxSize(n)
    if (n.leftBottomDip.size < nBoxSize * smallSideDipSizeLimit) return false;
    if (n.leftBottomDip.height < bottomDipHeightRatioLimit * numberHeight) return false;
    return true;
}
var leftDipHeightLimit = 0.3
var ruleLeftDipIsHigh = function () {
    if (numberHeight == 0) return false;
    if (n.leftDip.height / numberHeight < leftDipHeightLimit) return false;
    return true;

}
var rightDipHeightLimit = 0.45
var rulerightDipIsHigh = function () {
    if (numberHeight == 0) return false;
    if (n.rightDip.height / numberHeight < rightDipHeightLimit) return false;
    return true;

}
var bottomDipSizeLimit = largeSideDipSizeLimit
var ruleLargeFloorDip = function () {
    if (n.floorDip.size < nBoxSize * largeSideDipSizeLimit) return false;
    return true;
}
var leftDipSizeRatioLimit = 3
var rightDipSizeRatioLimit = leftDipSizeRatioLimit
var ruleLeftTopDipIsLarge = function () {
    if (n.leftTopDip.size != 0 && n.leftBottomDip.size == 0) return true;
    if (n.leftTopDip.size == 0 && n.leftBottomDip.size == 0) return false;
    if (n.leftTopDip.size / n.leftBottomDip.size < (leftDipSizeRatioLimit / 2)) return false;
    return true;
}
var bottomDipHeightRatioLimit = 0.14
var ruleLeftBottomDipIsLargeFor9 = function () {
    if (n.leftBottomDip.size < largeSideDipSizeLimit * nBoxSize) return false;
    if (n.leftBottomDip.height < bottomDipHeightRatioLimit * numberHeight) return false;
    return true;
}

var ruleLeftBottomDipIsLarge = function () {
    if (n.leftBottomDip.size != 0 && n.leftTopDip.size == 0) return true;
    if (n.leftBottomDip.size == 0 && n.leftTopDip.size == 0) return false;
    if (n.leftBottomDip.size / n.leftTopDip.size < leftDipSizeRatioLimit) return false;
    return true;
}
var ruleLeftBottomDipIsLargeFor5WithShortFeet = function () {
    if (n.leftBottomDip.size != 0 && n.leftTopDip.size == 0) return true;
    if (n.leftBottomDip.size == 0 && n.leftTopDip.size == 0) return false;
    if (n.leftBottomDip.size < n.leftTopDip.size * leftDipSizeRatioLimit * 0.7) return false;
    return true;
}
var leftRayDipSizeRatioLimit = 2
var rightRayDipSizeRatioLimit = leftRayDipSizeRatioLimit
var ruleLeftTopRayDipIsLargeComparedToBottom = function () {
    if (n.leftTopRayDip != 0 && n.leftBottomRayDip == 0) return true;
    if (n.leftTopRayDip == 0 && n.leftBottomRayDip == 0) return false;
    if (n.leftTopRayDip / n.leftBottomRayDip < (leftRayDipSizeRatioLimit)) return false;
    return true;
}
var leftRayDipSizeRatioLimitFor3 = 2.5
var ruleLeftTopRayDipIsLargeComparedToBottomFor3 = function () {
    if (n.leftTopRayDip != 0 && n.leftBottomRayDip == 0) return true;
    if (n.leftTopRayDip == 0 && n.leftBottomRayDip == 0) return false;
    if (n.leftTopRayDip / n.leftBottomRayDip < (leftRayDipSizeRatioLimitFor3)) return false;
    return true;
}
var ruleLeftBottomRayDipIsLargeComparedToTop = function () {
    if (n.leftBottomRayDip != 0 && n.leftTopRayDip == 0) return true;
    if (n.leftBottomRayDip == 0 && n.leftTopRayDip == 0) return false;
    if (n.leftBottomRayDip / n.leftTopRayDip < leftRayDipSizeRatioLimit) return false;
    return true;
}
var ruleLeftBottomRayDipIsLargeComparedToTopFor3WithSmallTop = function () {
    if (n.leftBottomRayDip != 0 && n.leftTopRayDip == 0) return true;
    if (n.leftBottomRayDip == 0 && n.leftTopRayDip == 0) return false;
    if (n.leftBottomRayDip < n.leftTopRayDip * leftRayDipSizeRatioLimit) return false;
    if (n.leftBottomRayDip > n.leftTopRayDip * 2 * leftRayDipSizeRatioLimit) return false;
    return true;
}

var ruleRightTopRayDipIsLargeFor9 = function () {
    if (n.rightTopRayDip != 0 && n.rightBottomRayDip == 0) return true;
    if (n.rightTopRayDip == 0 && n.rightBottomRayDip == 0) return false;
    if (n.rightTopRayDip / n.rightBottomRayDip < (rightRayDipSizeRatioLimit)) return false;
    return true;
}
var dipVersusRayDipRatioLimit = 6
var ruleRightTopDipIsLargeComparedToTopRayDip = function () {
    if (n.rightTopDip.size != 0 && n.rightTopRayDip == 0) return true;
    if (n.rightTopDip.size == 0 && n.rightTopRayDip == 0) return false;
    if (n.rightTopDip.size / n.rightTopRayDip < dipVersusRayDipRatioLimit) return false;
    return true;
}
var rightDipVersusRayDipRatioLimitFor6 = 25
var ruleRightTopDipIsLargeComparedToTopRayDipFor6 = function () {
    if (n.rightTopDip.size != 0 && n.rightTopRayDip == 0) return true;
    if (n.rightTopDip.size == 0 && n.rightTopRayDip == 0) return false;
    if (n.rightTopDip.size / n.rightTopRayDip < rightDipVersusRayDipRatioLimitFor6) return false;
    return true;
}
var ruleLeftTopDipIsLargeComparedToTopRayDip = function () {
    if (n.leftTopDip.size != 0 && n.leftTopRayDip == 0) return true;
    if (n.leftTopDip.size == 0 && n.leftTopRayDip == 0) return false;
    if (n.leftTopDip.size / n.leftTopRayDip < dipVersusRayDipRatioLimit) return false;
    return true;
}
var ruleRightBottomDipIsLargeComparedToBottomRayDip = function () {
    if (n.rightBottomDip.size != 0 && n.rightBottomRayDip == 0) return true;
    if (n.rightBottomDip.size == 0 && n.rightBottomRayDip == 0) return false;
    if (n.rightBottomDip.size < n.rightBottomRayDip * dipVersusRayDipRatioLimit) return false;
    return true;
}
var dipVersusRayDipRatioLimitFor9 = 30
var ruleLeftBottomDipIsLargeComparedToBottomRayDipFor9 = function () {
    if (n.leftBottomDip.size != 0 && n.leftBottomRayDip == 0) return true;
    if (n.leftBottomDip.size == 0 && n.leftBottomRayDip == 0) return false;
    if (n.leftBottomDip.size / n.leftBottomRayDip < dipVersusRayDipRatioLimitFor9) return false;
    return true;
}
var dipVersusRayDipRatioLimitFor5 = 3.5
var ruleLeftBottomDipIsLargeComparedToBottomRayDipFor5 = function () {
    if (n.leftBottomDip.size != 0 && n.leftBottomRayDip == 0) return true;
    if (n.leftBottomDip.size == 0 && n.leftBottomRayDip == 0) return false;
    if (n.leftBottomDip.size / n.leftBottomRayDip < dipVersusRayDipRatioLimitFor5) return false;
    return true;
}
var leftDipVersusRayDipRatioLimitFor6 = 5
var ruleLeftBottomDipIsLargeComparedToBottomRayDipFor6 = function () {
    if (n.leftBottomDip.size != 0 && n.leftBottomRayDip == 0) return true;
    if (n.leftBottomDip.size == 0 && n.leftBottomRayDip == 0) return false;
    if (n.leftBottomDip.size / n.leftBottomRayDip < leftDipVersusRayDipRatioLimitFor6) return false;
    return true;
}

var ruleRightBottomRayDipIsLargeFor6 = function () {
    if (n.rightBottomRayDip != 0 && n.rightTopRayDip == 0) return true;
    if (n.rightBottomRayDip == 0 && n.rightTopRayDip == 0) return false;
    if (n.rightBottomRayDip / n.rightTopRayDip < 1 / rightRayDipSizeRatioLimit) return false;
    return true;
}
var ruleRightTopDipIsLarge = function () {
    if (n.rightTopDip.size != 0 && n.rightBottomDip.size == 0) return true;
    if (n.rightTopDip.size == 0 && n.rightBottomDip.size == 0) return false;
    if (n.rightTopDip.size / n.rightBottomDip.size < rightDipSizeRatioLimit) return false;
    return true;
}
var ruleRightBottomDipIsLarge = function () {
    if (n.rightBottomDip.size != 0 && n.rightTopDip.size == 0) return true;
    if (n.rightBottomDip.size == 0 && n.rightTopDip.size == 0) return false;
    if (n.rightBottomDip.size / n.rightTopDip.size < rightDipSizeRatioLimit) return false;
    return true;
}
function validHole(i) {
    //    var numberSize = numberBoxSize(n)
    if (n.holes[i].size * 0.67 < numberWidth * holeSizeLimit * numberWidth) return false;
    if (verticalMidSection(n.holes[i].xG, n.holes[i].yG) == 0) return false;
    if (n.holes[0].height > validHoleHeightWidthRatioLimitRatio * n.holes[0].width) return false;
    if (n.holes[0].width > validHoleHeightWidthRatioLimitRatio * n.holes[0].height) return false;
    return true;
}
var holeSizeLimit = 0.040
var validHoleHeightWidthRatioLimitRatio = 3
var ruleHoles = function () {
    if (n.holes.length == 0) return false;
    if (n.holes[0].size < smallHoleLimitRatio * nBoxSize) return false;
    return true;
}
var smallHoleLimitRatio = 0.025
var ruleOneLargeHoleIn1 = function () {
    if (n.holes.length == 0) return false;
    if (n.holes.length > 1) {
        if (n.holes[1].size > smallHoleLimitRatio * nBoxSize) return false;
    }
    if (validHole(0) == false) return false;
    if (verticalMidSection(n.holes[0].xG, n.holes[0].yG) == 2) return false
    return true;
}
var ruleOnlyOneHole = function () {
    if (n.holes.length > 1) return false;
    return true;
}
var ruleOneLargeHoleIn2 = function () {
    //    var numberSize = numberBoxSize(n)
    if (n.holes.length == 0) return false;
    if (n.holes.length > 1) {
        if (n.holes[1].size > smallHoleLimitRatio * nBoxSize) return false;
    }
    if (validHole(0) == false) return false;
    if (verticalMidSection(n.holes[0].xG, n.holes[0].yG) == 1) return false
    return true;
}
var fullNumberHeightLimit = 0.70
var ruleFullNumberVisibleFor0 = function () {
    if (numberHeight < conf.numberMaxHeight * fullNumberHeightLimit * 1.1) return false
    return true;
}
var ruleFullNumberVisible = function () {
    if (numberHeight < conf.numberMaxHeight * fullNumberHeightLimit) return false
    return true;
}
var ruleNumberIsHigherThanMaxNumberHeight = function () {
    if (numberHeight < conf.numberMaxHeight + 8) return false;
    return true;
}
var ruleNumberIsInBottomHalfOfThePage = function () {
    if ((n.number.oY + numberHeight * 0.5) < n.pageHeight * 0.49) return false;
    return true;
}
var ruleFullNumberVisibleFor4WithHole = function () {
    //    if (n.number.oY == 0) return false;
    if ((n.pageHeight - n.number.oY) < (1.05 * conf.numberMaxHeight * fullNumberHeightLimit)) return false
    if (numberHeight < conf.numberMaxHeight * fullNumberHeightLimit) return false
    return true;
}
var number4smallHoleLimitRatio = 0.30
var ruleOneSmallHoleFor4WithSmallHole = function () {
    if (n.holes.length != 1) return false;
    if (n.holes[0].size > n.number.size * number4smallHoleLimitRatio) return false;
    if (n.holes[0].size < n.number.size * number4smallHoleLimitRatio * 0.25) return false;
    return true;
}
var holeSizeRatio = 1.5
var holeWidthRatio = 1.8
var ruleTwoAboutSameSizeHoles = function () {
    if (numberWidth == 0) return false;
    var relativeNumberHeightToWidthRatio = 0.67 * numberHeight / numberWidth
    if (n.holes.length < 2) return false;
    if (n.holes[0].yG < n.holes[1].yG) {
        if (n.holes[0].size * relativeNumberHeightToWidthRatio < nBoxSize * holeSizeLimit) return false;
        if (n.holes[1].size < nBoxSize * holeSizeLimit) return false;
    } else {
        if (n.holes[1].size * relativeNumberHeightToWidthRatio < nBoxSize * holeSizeLimit) return false;
        if (n.holes[0].size < nBoxSize * holeSizeLimit) return false;
    }
    if (verticalMidSection(n.holes[0].xG, n.holes[0].yG) == 0) return false;
    if (verticalMidSection(n.holes[1].xG, n.holes[1].yG) == 0) return false;
    var size0 = n.holes[0].size
    var size1 = n.holes[1].size
    if (n.holes[0].yG < n.holes[1].yG) {
        if (size0 > holeSizeRatio * size1) return false;
        if (size1 > holeSizeRatio * size0 * 4) return false;
    } else {
        if (size0 > holeSizeRatio * size1 * 4) return false;
        if (size1 > holeSizeRatio * size0) return false;
    }
    return true;
}
var highHoleHeightLimit = 0.62
var highHoleMaxRatio = 0.35
var ruleHoleIsVeryHigh = function () {
    if (n.holes.length == 0) return false;
    if ((n.holes[0].height < numberHeight * highHoleHeightLimit)) return false;
    return true;
}
var ruleHoleIsVeryHighFor0 = function () {
    if (n.holes.length == 0) return false;
    if ((n.holes[0].height < numberHeight * highHoleHeightLimit) && (n.holes[0].width > highHoleMaxRatio * numberHeight)) return false;
    return true;
}
var ruleHoleIsNotVeryHigh = function () {
    if (n.holes.length == 0) return false;
    if ((n.holes[0].height / numberHeight) > highHoleHeightLimit * 0.8) return false
    return true;
}
var highDipHeightLimit = 0.62
var ruleFloorDipIsVeryHigh = function () {
    if (n.floorDip.size == 0) return false;
    if (n.floorDip.height < highDipHeightLimit * numberHeight) return false
    return true;
}
var zeroHoleWidthToHeightMinRatioLimit = 0.25
var zeroHoleWidthToHeightMaxRatioLimit = 0.90
var ruleHoleIsNarrowOvale = function () {
    if (n.holes.length == 0) return false;
    if (n.holes[0].width * numberHeight * 0.67 > zeroHoleWidthToHeightMaxRatioLimit * n.holes[0].height * numberWidth) return false;
    if (n.holes[0].width * numberHeight * 0.67 < zeroHoleWidthToHeightMinRatioLimit * n.holes[0].height * numberWidth) return false;
    return true;
}
var numberOvalityLimitFor6 = 1000
var ruleNumberOvalityIsNormalFor6 = function () {
    if (n.number.ovality > numberOvalityLimitFor6) return false;
    return true
}
var ruleLeftBottomLegIn3 = function () {
    var legX = (n.leftBottomEdge.x + n.floorLeftEdge.x) * 0.3
    var legY = (n.leftBottomEdge.y + n.floorLeftEdge.y) * 0.5
    if (corner(legX, legY) != 3) return false
    return true;
}

var ruleLeftTopEdgeIn1 = function () {
    if (corner(n.leftTopEdge.x, n.leftTopEdge.y) != 1) return false
    return true;
}
var ruleRightBottomEdgeIn2 = function () {
    if (corner(n.rightBottomEdge.x, n.rightBottomEdge.y) != 2) return false
    return true;
}
var ruleRightBottomEdgeIn4 = function () {
    if (corner(n.rightBottomEdge.x, n.rightBottomEdge.y) != 4) return false
    return true;
}
var ruleRightTopEdgeIn4 = function () {
    if (corner(n.rightTopEdge.x, n.rightTopEdge.y) != 4) return false
    return true;
}
var ruleFloorRightEdgeIn3 = function () {
    if (corner(n.floorRightEdge.x, n.floorRightEdge.y) != 3) return false
    return true;
}

var ruleNoSideDipsFor8 = function () {
    if (n.rightDip.size > 0 && n.leftDip.size > 0) return false;
    return true;
}
var ruleNoLeftDipFor8 = function () {
    if (n.leftDip.size == 0) return true;
    if (n.leftDip.width >= 2) return false;
    return true;
}
var noDipLimit = 0.012
var ruleNoRightDip = function () {
    if (n.rightDip.size > nBoxSize * noDipLimit) return false;
    return true;
}
var ruleMinimalRightDip = function () {
    var limit = nBoxSize * noDipLimit * 0.25
    if (limit < 1) limit = 1
    if (n.rightDip.size > limit) return false;
    return true;
}
var ruleNoWideRightDip = function () {
    if (n.rightDip.size > 0.5 * numberHeight) return false;
    if (n.rightDip.width > 1) return false;
    return true;
}
var ruleNoRightDipFor9 = function () {
    if (n.rightDip.size > 0) return false;
    return true;
}
var ruleNoRightDipFor7 = function () {
    if (n.rightDip.size > nBoxSize * noDipLimit * 0.5) return false;
    if (n.rightDip.width > 2) return false;
    return true;
}
var largeRightDipRatioLimit = 0.15
var ruleNoLargeRightDip = function () {
    if (n.rightDip.size > nBoxSize * noDipLimit * 3) return false;
    if (n.rightDip.width > numberWidth * largeRightDipRatioLimit) return false;
    return true;
}
var ruleNoRightRayDip = function () {
    if (n.rightRayDip > nBoxSize * noDipLimit) return false;
    return true;
}
var ruleNoLeftDip = function () {
    if (n.leftDip.size > nBoxSize * noDipLimit) return false;
    return true;
}
var ruleNoLeftDipFor1WithTopTBar = function () {
    if (n.leftDip.size > nBoxSize * noDipLimit * 0.4) return false;
    return true;
}
var ruleNoLeftDipFor6 = function () {
    if (n.leftDip.size > nBoxSize * noDipLimit * 0.5) return false;
    return true;
}
var ruleNoRoofDip = function () {
    if (n.roofDip.size > nBoxSize * noDipLimit) return false;
    return true;
}
var ruleNoFloorDip = function () {
    if (n.floorDip.size > nBoxSize * noDipLimit) return false;
    return true;
}
var noTopRayDipLimit = 0.20
var ruleNoLeftTopRayDip = function () {
    if (n.leftTopRayDip > n.leftRayDip * noTopRayDipLimit) return false;
    return true;
}
var noRayDipLimit = 0.012
var ruleNoRightRayDip = function () {
    if (n.rightRayDip > nBoxSize * noRayDipLimit) return false;
    return true;
}
var ruleNoLargeRightBottomRayDip = function () {
    if (n.rightBottomRayDip > nBoxSize * noRayDipLimit * 2) return false;
    return true;
}
var topRightEdgeDistanceFromRightLimit = 0.20
var ruleTopRightEdgeIsNearRightSide = function () {
    if ((n.number.x + numberWidth - n.roofRightEdge.x) / numberWidth > topRightEdgeDistanceFromRightLimit) return false;
    return true;
}
var rightButtWidthLimitRatio = 0.09
var ruleRightButtExists = function () {
    if (n.leftRadar.topIndex <= n.rightTopEdge.y && n.leftRadar.bottomIndex >= n.rightBottomEdge.y) return true;
    if (n.rightBottomEdge.x - n.floorRightEdge.x < rightButtWidthLimitRatio * numberWidth) return false;
    return true;
}
var topBarBottomCurveSizeLimitRatio = 0.014
var ruleTopBarBottomIsCurved = function () {
    if (n.topBarBottomCurve.size <= nBoxSize * topBarBottomCurveSizeLimitRatio) return false;
    return true;
}
var ruleTopBarBottomCurveSizeIsExcessive = function () {
    if (n.topBarBottomCurve.size < n.leftBottomDip.size) return false;
    return true;
}
var diagonalBarCurveSizeLimit = 5
var ruleDiagonalBarIsCurved = function () {
    if (n.diagonalBarCurve.size <= diagonalBarCurveSizeLimit) return false
    return true
}
var diagonalBarCurveSizeLimitRatioFor7 = 0.015
var ruleDiagonalBarIsCurvedFor7 = function () {
    if (n.diagonalBarCurve.size <= diagonalBarCurveSizeLimitRatioFor7 * nBoxSize) return false
    return true
}
var rightTopDipDiagonalCurveSizeLimit = 5
var ruleRightTopDipDiagonalIsCurved = function () {
    if (n.rightTopDipDiagonalCurve.size <= rightTopDipDiagonalCurveSizeLimit) return false
    return true
}
var ruleRightTopDipDiagonalIsCurvedFor4 = function () {
    if ((n.rightTopDipDiagonalCurveFor4.size + n.rightTopDipDiagonalCurve.size) <= rightTopDipDiagonalCurveSizeLimit) return false
    return true
}
var roofLeftCurveSizeLimit = 5
var ruleRoofLeftSideIsCurved = function () {
    if (n.roofLeftCurve.size < roofLeftCurveSizeLimit) return false;
    return true;
}
var rightSideConvexSizeLimit = 0.8
var ruleRightSideIsClearlyConcave = function () {
    if (n.rightConvex < (-numberHeight * rightSideConvexSizeLimit)) return true;
    return false;
}
var ruleRightSideIsClearlyConvex = function () {
    if (n.rightConvex > (numberHeight * rightSideConvexSizeLimit)) return true;
    return false;
}
var roofTopConvexSizeLimit = 1
var ruleroofTopIsConvex = function () {
    if (n.roofTopConvex < roofTopConvexSizeLimit * numberWidth) return false;
    return true;
}

var roofLeftConvexSizeLimit = 2
var ruleRoofLeftSideIsConvex = function () {
    if (n.roofLeftConvex.size < roofLeftConvexSizeLimit) return false;
    return true;
}
var floorLeftCurveSizeLimit = 0
var ruleFloorLeftIsCurved = function () {
    if (n.floorLeftCurve.size <= floorLeftCurveSizeLimit) return false;
    return true;
}
var ruleFloorLeftIsCurvedFor4 = function () {
    if (n.floorLeftCurveFor4.size <= floorLeftCurveSizeLimit) return false;
    return true;
}
var roofWidthLimit = 0.5
var roofHeightLimit = 0.16
var ruleRoofIsNarrowAndHorisontalFor4WithHole = function () {

    if (n.roofRightEdge.x - n.roofLeftEdge.x > roofWidthLimit * numberWidth) return false;
    if (Math.abs(n.roofRightEdge.y - n.roofLeftEdge.y) > roofHeightLimit * numberHeight) return false
    return true;
}
var ruleRoofIsNarrowAndHorisontalFor4WithDip = function () {

    if (n.rightTopEdge.x - n.roofLeftEdge.x > roofWidthLimit * numberWidth) return false;
    if (Math.abs(n.rightTopEdge.y - n.roofLeftEdge.y) > roofHeightLimit * numberHeight) return false
    return true;
}
var floorWidthLimit = 0.5
var ruleFloorIsNarrowFor1 = function () {
    if (n.floorRightEdge.x - n.floorLeftEdge.x > floorWidthLimit * conf.numberMaxWidth) return false;
    return true;
}
var ruleFloorIsNarrowFor1WithHangingNose = function () {
    if ((n.floorRightEdge.x - n.floorDip.x - n.floorDip.width) > floorWidthLimit * conf.numberMaxWidth) return false;
    return true;
}
var floorDipEdgeSymmetryLimit = 0.15
var ruleFloorDipEgdesAreSymmetric = function () {
    if (Math.abs(n.floorLeftEdge.y - n.floorRightEdge.y) / numberHeight > floorDipEdgeSymmetryLimit) return false
    return true;
}
var ruleFloorIsNarrowFor7 = function () {

    if (n.floorRightEdge.x - n.leftBottomEdge.x > floorWidthLimit * conf.numberMaxWidth) return false;
    return true;
}
var holeDipsLimit = 10
var leftAndRightHoleDipsRatio = 5
var ruleHoleHasDipsOnBothSides = function () {
    if (n.holeDips.size == 0) return false;
    if (n.holeDips.leftSize == 0) return false;
    if (n.holeDips.rightSize == 0) return false;
    if (n.holeDips.rightSize > leftAndRightHoleDipsRatio * n.holeDips.leftSize) return false
    if (n.holeDips.leftSize + n.holeDips.rightSize <= holeDipsLimit) return false;
    return true;
}
var ruleHoleHasDips = function () {
    if (n.holeDips.leftSize + n.holeDips.rightSize <= holeDipsLimit) return false;
    return true;
}
var leftDipSizeLimitFor7 = 30
var ruleLeftDipIsSmallFor7 = function () {
    if (n.leftDip.size > leftDipSizeLimitFor7) return false;
    return true;
}
var leftTopTiltHeightLimit = 0.4

var leftTopTiltAngleLimit = 0.20
var leftTopHeightLimit = 0.28
var ruleLeftTopTiltsRight = function () {
    if (n.leftTopTilt.dY < numberHeight * leftTopTiltHeightLimit) return false;
    if (n.leftTopTilt.dX * numberWidth < n.leftTopTilt.dY * leftTopTiltAngleLimit * 0.66 * numberHeight) return false;
    if (n.leftTopEdge.y < leftTopHeightLimit * numberHeight) return false;
    return true;
}
var leftTopTiltWidthRatioLimit = 0.2
var ruleLeftTopTiltsRightFor4Narrow = function () {
    if (n.leftTopTilt.dY < numberHeight * leftTopTiltHeightLimit) return false;
    if (n.leftTopTilt.dX < leftTopTiltWidthRatioLimit * numberWidth) return false;
    if (n.leftTopEdge.y < leftTopHeightLimit * numberHeight) return false;
    return true;
}
var rightBottomTiltHeightLimit = 0.60

var rightBottomAngleLimit = 0.10
var ruleRightBottomTiltsRight = function () {
    if (n.rightBottomTilt.dY / numberHeight < rightBottomTiltHeightLimit) return false;
    if (n.rightBottomTilt.dX / n.rightBottomTilt.dY < rightBottomAngleLimit) return false
    return true;
}
var rightBottomConvexLimit = 2
var ruleRightBottomIsClearlyConvex = function () {
    if (n.rightBottomTilt.convex < rightBottomConvexLimit * numberHeight) return false;
    return true;
}
var roofRadarRatioLimitFor1 = 0.6
var ruleOneIsUpRight = function () {
    if (n.number.size == 0) return false;
    if (n.roofRadar.size < n.number.size * roofRadarRatioLimitFor1) return false
    return true;
}
var ruleOneIsUpRightFor1WithHangingNose = function () {
    if (n.number.size == 0) return false;
    if (n.roofRadar.size < n.number.size * roofRadarRatioLimitFor1 * 0.90) return false
    return true;
}
var longPartRightMaxDistance = 3
var ruleLongPartIsOnTheRight = function () {
    if ((numberWidth - n.roofRadar.rightIndex) > longPartRightMaxDistance) return false;
    return true;
}
var noseMaxDistanceFromTopRatio = 0.45
var ruleNoseIsInTopPartOfNumber = function () {
    if (n.leftRadar.bottomIndex > numberHeight * noseMaxDistanceFromTopRatio) return false
    return true;
}
var horisontalLinePositionLimit = 0.5
var ruleHorisontalLineInTheBottomHalf = function () {
    if (n.leftRadar.count == 0) return false;
    if (n.leftRadar.bottomIndex < horisontalLinePositionLimit * numberHeight) return false;
    return true;
}
var ruleOneIsInTheMiddle = function () {
    if (n.roofRadar.count == 0) return false;
    if ((n.roofRadar.leftIndex + n.roofRadar.rightIndex) < (numberWidth * 0.66)) return false
    if ((n.roofRadar.leftIndex + n.roofRadar.rightIndex) > (numberWidth * 1.33)) return false
    if ((n.roofRadar.count - n.roofRadar.rightIndex + n.roofRadar.leftIndex) != 1) return false
    return true;
}
var tBarOneIsHighLimit = 0.78
var ruleTBarOneIsHigh = function () {
    var maxi = n.roofRadar.max
    if (n.floorRadar.max > maxi) maxi = n.floorRadar.max
    if (maxi < tBarOneIsHighLimit * conf.numberMaxHeight) return false
    return true
}
var tBarOneRadarRatio = 0.70
var ruleTBarAndOneCoverMostArea = function () {
    var maxi = n.roofRadar.size
    if (n.floorRadar.size > maxi) maxi = n.floorRadar.size
    if ((maxi + n.leftRadar.size) < tBarOneRadarRatio * n.number.size) return false;
    return true;
}
var tBarMaximumHeight = 4
var ruleNumberHasTopTBar = function () {
    if (n.leftRadar.topIndex != 0) return false;
    if (n.leftRadar.bottomIndex > tBarMaximumHeight) return false;
    if (n.leftRadar.count - n.leftRadar.bottomIndex + n.leftRadar.topIndex != 1) return false;
    if (n.leftRadar.max < tBarMaxRatioLimit * n.pageWidth) return false;
    return true;
}
var sevenTopBarTopLimitRatio = 0.10
var sevenTopBarWidthLimitRatio = 0.8
var sevenTopBarHeightLimitRatio = 0.25
var ruleNumberSevenHasTopBar = function () {
    if (n.leftRadar.topIndex > sevenTopBarTopLimitRatio * numberHeight) return false;
    if (n.leftRadar.bottomIndex - n.leftRadar.topIndex > sevenTopBarHeightLimitRatio * numberHeight) return false;
    if (n.leftRadar.count - n.leftRadar.bottomIndex + n.leftRadar.topIndex != 1) return false;
    if (n.leftRadar.max < sevenTopBarWidthLimitRatio * numberWidth) return false;
    return true;
}
var tBarMaxRatioLimit = 0.6
var ruleNumberHasBottomTBar = function () {
    if (n.leftRadar.bottomIndex < numberHeight - 2) return false;
    if (n.leftRadar.topIndex < numberHeight - 1 - tBarMaximumHeight) return false;
    if (n.leftRadar.count - n.leftRadar.bottomIndex + n.leftRadar.topIndex != 1) return false;
    if (n.leftRadar.max < tBarMaxRatioLimit * n.pageWidth) return false;
    return true;
}
var radarRightSideLimitfor0Ratio = 0
var radarBottomSideLimitFor0Ratio = 0.25
var ruleRadarsIndicateZero = function () {
    if (n.roofRadar.count == 0) return true;
    if (numberWidth - 1 - n.roofRadar.rightIndex < numberWidth * radarRightSideLimitfor0Ratio) {
        if (n.roofRadar.count - n.roofRadar.rightIndex + n.roofRadar.leftIndex == 1) {
            if (n.roofRadar.count > 2) return false;
        }
    }
    if (n.leftRadar.count == 0) return true;
    if (numberHeight - n.leftRadar.bottomIndex > radarBottomSideLimitFor0Ratio * numberHeight) {
        if (n.leftRadar.count > 2) {
            if (n.leftRadar.count - n.leftRadar.bottomIndex + n.leftRadar.topIndex == 1) return false;
        }
    }
    return true;
}
var ruleRadarsIndicate2 = function () {
    if (n.roofRadar.count != 0) return false;
    if (n.leftRadar.count == 0) return false;
    return true;
}
var ruleRadarsIndicate4WithHole = function () {
    if (n.roofRadar.count == 0) return false;
    if (n.leftRadar.count == 0) return false;
    if (n.roofRadar.leftIndex < numberWidth * 0.45) return false;
    if (n.roofRadar.count - n.roofRadar.rightIndex + n.roofRadar.leftIndex != 1) return false;
    if (n.leftRadar.topIndex < numberHeight * 0.5) return false;
    if (n.leftRadar.count - n.leftRadar.bottomIndex + n.leftRadar.topIndex != 1) return false;
    return true;
}
var ruleRadarsIndicate9 = function () {
    if (n.leftRadar.count == 0) return false;
    if (n.roofRadar.count != 0) {
        if (n.roofRadar.leftIndex < 0.5 * numberWidth) return false;
    }

    //    if (n.leftRadar.count == 1) return true;
    //    if (n.roofRadar.count==0)return false;
    //    if(n.roofRadar.leftIndex<0.4*numberWidth)return false;
    //    if (n.roofRadar.count - n.roofRadar.rightIndex + n.roofRadar.leftIndex != 1) return false;
    //    if (n.leftRadar.count - n.leftRadar.bottomIndex + n.leftRadar.topIndex == 1) return false;
    return true;
}
var roofRadarCountMaxLimitRatioFor6WithoutDip = 0.43
var roofRadarCountMinLimitRatioFor6WithoutDip = 0.17
var leftRadarTopIndexMinLimitRatioFor6WithoutDip = 0.25
var leftRadarBottomIndexMaxLimitRatioFor6WithoutDip = 0.80
var ruleradarsIndicate6WithoutTopDip = function () {
    if (n.roofRadar.count == 0) return false;
    if (n.roofRadar.leftIndex > 2) return false;
    //    if (n.roofRadar.count - n.roofRadar.rightIndex + n.roofRadar.leftIndex != 1) return false;
    if (n.roofRadar.count < roofRadarCountMinLimitRatioFor6WithoutDip * numberWidth) return false;
    if (n.roofRadar.count > roofRadarCountMaxLimitRatioFor6WithoutDip * numberWidth) return false;
    if (n.leftRadar.count == 0) return false;
    if (n.leftRadar.topIndex < numberHeight * leftRadarTopIndexMinLimitRatioFor6WithoutDip) return false;
    if (n.leftRadar.bottomIndex < numberHeight * leftRadarBottomIndexMaxLimitRatioFor6WithoutDip) return false;
    if (n.leftRadar.count - n.leftRadar.bottomIndex + n.leftRadar.topIndex == 1) return false;
    return true;
}
var ruleRadarsIndicate4WithHoleButNoRightBulge = function () {
    if (n.roofRadar.count == 0) return false;
    if (n.leftRadar.count == 0) return false;
    if (n.roofRadar.leftIndex < numberWidth * 0.55) return false;
    if (n.roofRadar.rightIndex < numberWidth * 0.75) return false;
    if (n.roofRadar.count - n.roofRadar.rightIndex + n.roofRadar.leftIndex != 1) return false;
    if (n.leftRadar.topIndex < numberHeight * 0.5) return false;
    if (n.leftRadar.count - n.leftRadar.bottomIndex + n.leftRadar.topIndex != 1) return false;
    return true;
}
var ruleRadarsIndicate4WithDip = function () {
    if (n.leftRadar.count == 0) return false;
    if (n.leftRadar.topIndex < numberHeight * 0.5) return false;
    if (n.leftRadar.count - n.leftRadar.bottomIndex + n.leftRadar.topIndex != 1) return false;
    return true;
}
var horisontalTopBarFor5Limit = 3
var horisontalTopBarWidthFor5LimitRatio = 0.5
var horisontalTopBarMaxWidthFor5LimitRatio = 0.9
var ruleHorisontalTopBarFor5 = function () {
    if (n.leftRadar.count == 0) return false;
    if (n.leftRadar.topIndex > horisontalTopBarFor5Limit) return false
    return true
}

var ruleNarrowHorisontalTopBarFor5 = function () {
    if (Math.abs(n.roofLeftEdge.y - n.roofRightEdge.y) < 2) {
        if (Math.abs(n.rightTopEdge.y - n.roofRightEdge.y) < 3) {
            if (Math.abs(n.roofLeftEdge.x - n.leftTopEdge.x) < 4) {
                if (Math.abs(n.rightTopEdge.x - 0.5 * (n.roofLeftEdge.x + n.leftTopEdge.x)) < horisontalTopBarMaxWidthFor5LimitRatio * numberWidth) {
                    if (Math.abs(n.rightTopEdge.x - 0.5 * (n.roofLeftEdge.x + n.leftTopEdge.x)) > horisontalTopBarWidthFor5LimitRatio * numberWidth) {
                        return true;
                    }
                }
            }
        }
    }
    return false
}
var ruleVerticalBarExists = function () {
    if (n.roofRadar.count == 0) return false
    return true;
}
var numberOneLeftPositionLimit = 0.33
var ruleOneIsInTheMiddleOfThePage = function () {
    if ((0.5 * (n.roofRadar.leftIndex + n.roofRadar.rightIndex) + n.number.oX) < n.pageWidth * numberOneLeftPositionLimit) return false;
    if ((0.5 * (n.roofRadar.leftIndex + n.roofRadar.rightIndex) + n.number.oX) > n.pageWidth * (1 - numberOneLeftPositionLimit)) return false;
    return true;
}
var topEdgeAndRoofRadarAlignmentLimit = 0.4
var oneEndWidthVersusRadarWidthRatioLimit = 1.5
var ruleTopEdgesAreAlignedWithRoofRadar = function () {
    if (n.roofRightEdge.x - n.roofLeftEdge.x > n.roofRadar.count * topWidthVersusRadarWidthRatioLimit) return false;
    if (n.roofRightEdge.x - n.roofRadar.rightIndex > topEdgeAndRoofRadarAlignmentLimit * n.roofRadar.count) return false
    if (n.roofRadar.leftIndex - n.roofLeftEdge.x > topEdgeAndRoofRadarAlignmentLimit * n.roofRadar.count) return false;
    return true;
}
var bottomEdgeAndFloorRadarAlignmentLimit = 0.4
var ruleBottomEdgesAreAlignedWithFloorRadar = function () {
    if (n.floorRightEdge.x - n.floorLeftEdge.x > n.floorRadar.count * oneEndWidthVersusRadarWidthRatioLimit) return false;
    if (n.floorRightEdge.x - n.floorRadar.rightIndex > bottomEdgeAndFloorRadarAlignmentLimit * n.floorRadar.count) return false
    if (n.floorRadar.leftIndex - n.floorLeftEdge.x > bottomEdgeAndFloorRadarAlignmentLimit * n.floorRadar.count) return false;
    return true;
}



var ruleFloorRightCornerIn4 = function () {
    if (n.corners.floorRight.distance > numberWidth / 2) return false;
    return true;
}
var ruleNumberIsLooseFromTopOfThePage = function () {
    if ((n.number.oY + n.number.y) == 0) return false;
    return true;
}
var leftRightDipRatioLimit = 1.8
var ruleDipsHaveEqualWidthFor5 = function () {
    if (n.rightDip.width > leftRightDipRatioLimit * n.leftDip.width) return false;
    if (n.leftDip.width > leftRightDipRatioLimit * n.rightDip.width) return false;
    return true;
}
var holeAndDipVerticalPositionLimit = 0.25
var holeAndDipWidthRatioLimit = 1.4
var holeAndDipHeightRatioLimit = 3
var ruleFloorDipAndHoleAreOnTopOfEachOtherAndWidthAndHeightAreaEqual = function () {
    if (n.holes.length == 0) return false
    if (n.floorDip.size == 0) return false
    if (Math.abs(n.holes[0].xG - n.floorDip.xG) > numberWidth * holeAndDipVerticalPositionLimit) return false;
    if (n.floorDip.width > holeAndDipWidthRatioLimit * n.holes[0].width) return false;
    if (n.holes[0].width > holeAndDipWidthRatioLimit * n.floorDip.width) return false;
    if (n.floorDip.height > holeAndDipHeightRatioLimit * n.holes[0].height) return false;
    if (n.holes[0].height > holeAndDipHeightRatioLimit * n.floorDip.height) return false;
    return true;
}
var ruleLeftTopDipAndHoleAreOnTopOfEachOtherAndWidthIsEqual = function () {
    if (n.holes.length == 0) return false
    if (n.leftTopDip.size == 0) return false
    if (Math.abs(n.holes[0].xG - n.leftTopDip.xG) > numberWidth * holeAndDipVerticalPositionLimit) return false;
    if (n.leftTopDip.width > holeAndDipWidthRatioLimit * n.holes[0].width) return false;
    if (n.holes[0].width > holeAndDipWidthRatioLimit * n.leftTopDip.width) return false;
    return true;
}
var ruleRightTopDipAndHoleAreOnTopOfEachOtherAndWidthIsEqual = function () {
    if (n.holes.length == 0) return false
    if (n.rightTopDip.size == 0) return false
    if (Math.abs(n.holes[0].xG - n.rightTopDip.xG) > numberWidth * holeAndDipVerticalPositionLimit) return false;
    if (n.rightTopDip.width > holeAndDipWidthRatioLimit * n.holes[0].width) return false;
    if (n.holes[0].width > holeAndDipWidthRatioLimit * n.rightTopDip.width) return false;
    return true;
}
var topHoleSizeLimit = 0.90
var ruleTopHoleIsSmallerThanBottomHole = function () {
    if (n.holes.length > 2 && n.holes[2].size > (smallHoleLimitRatio * nBoxSize)) return false;
    if (n.holes.length < 2) return false;
    if (n.holes[0].yG < n.holes[1].yG) {
        if (n.holes[0].size > topHoleSizeLimit * n.holes[1].size) return false
    } else {
        if (n.holes[1].size > topHoleSizeLimit * n.holes[0].size) return false
    }
    return true;
}
var holeWidthLimit = 0.40
var ruleHoleIsWideComparedToNumberWidth = function () {
    if (numberWidth == 0) return false;
    var relativeNumberHeightToWidthRatio = 0.67 * numberHeight / numberWidth
    if (n.holes.length == 0) return false;
    if (n.holes[0].width * relativeNumberHeightToWidthRatio < holeWidthLimit * numberWidth) return false;
    return true;
}
var dipHoleAlignmentLimitRatio = 0.15
var dipHoleHeightLimitRatio = 1.2
var ruleHoleIsBelowDipFor6WithSmallHole = function () {
    if (n.holes.length == 0) return false;
    if (Math.abs(n.holes[0].x - n.rightTopDip.x) > dipHoleAlignmentLimitRatio * numberWidth) return false;
    if (n.holes[0].Height > n.rightTopDip.Height * dipHoleHeightLimitRatio) return false;
    if (n.holes[0].Height * dipHoleHeightLimitRatio < n.rightTopDip.Height) return false;
    return true;

}
var ruleHoleIsWideComparedToNumberWidthFor6WithLeftTopBox = function () {
    if (n.holes.length == 0) return false;
    if (n.holes[0].width < holeWidthLimit * numberWidth * 0.9) return false;
    return true;
}
var ruleMinimalRightBottomDip = function () {
    if (n.rightBottomDip.size > 1) return false;
    return true;
}
var ruleLeftDipHeightIsLargerThanWidth = function () {
    if (n.leftDip.size == 0) return 0
    if (n.leftDip.height < n.leftDip.width) return false
    return true
}
var holeToDipSizeRatioLimit = 0.49
var ruleHoleIsBigEnoughComparedToLeftBottomDip = function () {
    if (n.holes.length == 0) return false;
    if (n.holes[0].size < holeToDipSizeRatioLimit * n.leftBottomDip.size) return false
    return true
}
var holeOrDipHorisontalPositionLimit = 0.35
var ruleHoleIsInTheMiddleOfTheNumber = function () {
    if (n.holes.length == 0) return false
    if (n.holes[0].xG < holeOrDipHorisontalPositionLimit * numberWidth) return false
    if (n.holes[0].xG > (1 - holeOrDipHorisontalPositionLimit) * numberWidth) return false
    return true;
}
var ruleDipIsIntheMiddleOfTheNumber = function () {
    if (n.floorDip.size == 0) return false;
    if (n.floorDip.xG < holeOrDipHorisontalPositionLimit * numberWidth) return false
    if (n.floorDip.XG > (1 - holeOrDipHorisontalPositionLimit) * numberWidth) return false
    return true
}
var leftEdgeAlignmentLimitRatio = 0.2
var ruleleftEdgesAreVerticallyAligned = function () {
    if (Math.abs(n.leftTopEdge.x - n.leftBottomEdge.x) > leftEdgeAlignmentLimitRatio * numberWidth) return false
    return true;
}
var ruleTrueTest = function () {
    return true;
}
var ruleFalseTest = function () {
    return false;
}
var oneLeftRadarCountLimit = 0.5
var oneRoofRadarCountLimit = 0.6
var oneMinWidthToHeightRatio = 0.15
var oneMaxWidthToHeightRatio = 0.3
var ruleOneIsSquareBoxFor1NoNose = function () {
    if (n.leftRadar.count == 0) return false;
    if (numberWidth < oneMinWidthToHeightRatio * numberHeight) return false
    if (numberWidth > oneMaxWidthToHeightRatio * numberHeight) return false
    if ((n.leftRadar.count) < oneLeftRadarCountLimit * numberHeight && n.roofRadar.count < 0.5 * numberWidth) return false;
    if (n.roofRadar.count == 0) return false;
    if (n.roofRadar.count - n.roofRadar.rightIndex + n.roofRadar.leftIndex != 1) return false;
    if ((n.roofRadar.count) < oneRoofRadarCountLimit * numberWidth) return false;
    return true;
}
var radarDistanceFromRightFor7LimitRatio = 0.2
var ruleRadarsIndicate7 = function () {
    return true;
    if (n.roofRadar.count > 2) {
        if (n.rightTopEdge.x - n.roofRadar.rightIndex > radarDistanceFromRightFor7LimitRatio * numberWidth) return false;
    }
    if (n.roofRadar.count - n.roofRadar.rightIndex + n.roofRadar.leftIndex != 1) return false;
    return true;
}

var ruleOneIsSquareBoxFor1WithNose = function () {
    if (n.leftRadar.count == 0) return false;
    if (n.leftRadar.count - n.leftRadar.bottomIndex + n.leftRadar.topIndex != 1) return false;
    if (n.roofRadar.count == 0) return false;
    if (n.roofRadar.count - n.roofRadar.rightIndex + n.roofRadar.leftIndex != 1) return false;
    if ((n.roofRadar.count) < oneRoofRadarCountLimit * 0.45 * numberWidth) return false;
    if (n.floorRadar.count == 0) return false;
    if (n.floorRadar.count - n.floorRadar.rightIndex + n.floorRadar.leftIndex != 1) return false;
    if ((n.floorRadar.count) < oneRoofRadarCountLimit * 0.45 * numberWidth) return false;
    return true;
}
var ruleOneIsSquareBoxFor1WithHangingNose = function () {
    if (n.leftRadar.count == 0) return false;
    if (n.leftRadar.count - n.leftRadar.bottomIndex + n.leftRadar.topIndex != 1) return false;
    if (n.roofRadar.count == 0) return false;
    if (n.roofRadar.count - n.roofRadar.rightIndex + n.roofRadar.leftIndex != 1) return false;
    if ((n.roofRadar.count) < oneRoofRadarCountLimit * 0.30 * numberWidth) return false;
    if (n.floorRadar.count == 0) return false;
    if (n.floorRadar.count - n.floorRadar.rightIndex + n.floorRadar.leftIndex != 1) return false;
    if ((n.floorRadar.count) < oneRoofRadarCountLimit * 0.30 * numberWidth) return false;
    return true;
}
var bottomFeetHeightLimitRatio = 0.07
var bottomFeetWidthLimit = 0.45
var ruleBottomFeetExists = function () {
    if (n.floorRightEdge.y - n.rightBottomEdge.y < bottomFeetHeightLimitRatio * numberHeight) return false;
    if (n.floorRightEdge.x - n.floorLeftEdge.x > bottomFeetWidthLimit * numberWidth) return false;
    return true;
}
var ruleBottomFeetExistsButNoRightBulge = function () {
    if (n.floorRightEdge.y - n.leftBottomEdge.y < bottomFeetHeightLimitRatio * numberHeight) return false;
    if (n.floorRightEdge.x - n.floorLeftEdge.x > bottomFeetWidthLimit * numberWidth) {
        if (n.floorRightEdge.y - n.floorLeftEdge.y < bottomFeetHeightLimitRatio * numberHeight) return false;
    }
    return true;
}

var rightTiltRatioLimit = 0.17
var ruleVerticalBarTiltsRightIn1WithTopBar = function () {
    if (n.leftDip.size == 0) return false;
    if (n.leftBottomEdge.y < numberHeight * noseMaxDistanceFromTopRatio + n.leftRadar.bottomIndex) return false;
    if (n.leftDip.x + n.leftDip.width - n.leftBottomEdge.x < rightTiltRatioLimit * (n.leftBottomEdge.y - n.leftDip.y)) return false;
    return true;
}
var ruleNumberExtendsToBothRoofCorners = function () {
    if (n.corners.roofLeft.distance > 0) return false;
    if (n.corners.roofRight.distance > 0) return false;
    return true;
}
var ruleNumberExtendsToRoofLeftCorner = function () {
    if (n.corners.roofLeft.distance > 0) return false;
    return true;
}
var ruleNumberExtendsNearRoofLeftCorner = function () {
    if (n.corners.roofLeft.distance > 1) return false;
    return true;
}
var ruleNumberExtendsToFloorLeftCorner = function () {
    if (n.corners.floorLeft.distance > 0) return false;
    return true;
}
var ruleNumberExtendsToRoofRightCorner = function () {
    if (n.corners.roofRight.distance > 0) return false;
    return true;
}
var ruleNumberExtendsToFloorRightCorner = function () {
    if (n.corners.floorRight.distance > 0) return false;
    return true;
}
var holeHeightToWidthLimit = 1.5
var ruleHoleHeightIsBiggerThanWidth = function () {
    if (n.holes.length == 0) return false;
    if (n.holes[0].height < holeHeightToWidthLimit * n.holes[0].width) return false;
    return true;
}
var bottomLeftCornerEdgeDistanceLimit = 0.2
var ruleBottomLeftCornerIsValid = function () {
    if (n.floorLeftEdge.y < 0.5 * numberHeight) {
        if (Math.abs(n.corners.floorRight.y - n.corners.floorLeft.y) > bottomLeftCornerEdgeDistanceLimit * numberHeight) return false;
    } else {
        if (Math.abs(n.leftBottomEdge.y - n.floorLeftEdge.y) > bottomLeftCornerEdgeDistanceLimit * numberHeight) return false;
        if (Math.abs(n.floorLeftEdge.y - n.floorRightEdge.y) > bottomLeftCornerEdgeDistanceLimit * numberHeight) return false;
    }
    return true;
}
var ruleBottomLeftCornerAndTopLeftCornerIsValidFor7Wide = function () {
    if (n.floorLeftEdge.y < 0.5 * numberHeight) {
        if (Math.abs(n.corners.floorRight.y - n.corners.floorLeft.y) > bottomLeftCornerEdgeDistanceLimit * numberHeight) return false;
        if (n.corners.floorRight.x - n.corners.floorLeft.x > bottomLeftCornerEdgeDistanceLimit * numberWidth) return false;
        if (0.5 * (n.corners.floorLeft.x + n.corners.floorRight.x) > (1 - bottomLeftCornerEdgeDistanceLimit * 1.5) * numberWidth) return false;
    } else {
        if (Math.abs(n.leftBottomEdge.y - n.floorRightEdge.y) > bottomLeftCornerEdgeDistanceLimit * numberHeight) return false;
        if (Math.abs(n.leftBottomEdge.x - n.floorRightEdge.x) > bottomLeftCornerEdgeDistanceLimit * numberWidth) return false;
        if (0.5 * (n.leftBottomEdge.x + n.floorRightEdge.x) > (1 - bottomLeftCornerEdgeDistanceLimit * 1.5) * numberWidth) return false;
        if (0.5 * (n.leftBottomEdge.x + n.floorRightEdge.x) < bottomLeftCornerEdgeDistanceLimit * 1.5 * numberWidth) return false;
        if (Math.abs(n.leftTopEdge.y - n.floorLeftEdge.y) - n.leftRadar.count > bottomLeftCornerEdgeDistanceLimit * n.numberHeight) return false;
        if (Math.abs(n.leftTopEdge.x - n.floorLeftEdge.x) > bottomLeftCornerEdgeDistanceLimit * n.numberWidth) return false;
    }
    return true;
}
var ruleLeftBottomDipHasConcaveTopFor8 = function () {
    if (n.leftBottomDip.size == 0) return false;
    if (n.leftBottomDip.rayY == 0) return false;
    if (n.leftBottomDip.rayToDipTop < 2) return false;
    if (n.leftBottomDip.dipTopEdgeDistance > dipEdgeDistanceLimitRatio * numberWidth) return false;
    return true;
}
var ruleLeftBottomDipHasConcaveTopFor5 = function () {
    if (n.leftBottomDip.size == 0) return false;
    if (n.leftBottomDip.rayToDipTop < 2) return false;
    return true;
}
var ruleRightTopDipHasConcaveTopFor5 = function () {
    if (n.rightTopDip.size == 0) return false;
    if (n.rightTopDip.rayToDipTop < 2) return false;
    return true;
}
var ruleRightTopDipHasConcaveBottomFor6 = function () {
    if (n.rightTopDip.size == 0) return false;
    if (n.rightTopDip.rayToDipBottom < 2) return false;
    return true;
}
var dipEdgeDistanceLimitRatio = 0.24
var ruleRightTopDipHasConcaveBottomFor8 = function () {
    if (n.rightTopDip.size == 0) return false;
    if (n.rightTopDip.rayY == 0) return false;
    if (n.rightTopDip.rayToDipBottom < 1) return false;
    if (n.rightTopDip.dipBottomEdgeDistance > dipEdgeDistanceLimitRatio * numberWidth) return false;
    return true;
}
var dipTopEdgeDistanceLimitRatioFor9 = 0.14
var ruleLeftBottomDipHasConcaveTopFor9 = function () {
    if (n.leftBottomDip.size == 0) return false;
    if (n.leftBottomDip.rayToDipTop < 1) return false;
    if (n.leftBottomDip.dipTopEdgeDistance > dipTopEdgeDistanceLimitRatioFor9 * numberWidth) return false;
    return true;
}
var ruleLeftTopDipHasConcaveBottom = function () {
    if (n.leftTopDip.size == 0) return false;
    if (n.leftTopDip.rayToDipBottom < 2) return false;
    return true;
}
var rightTopEdgeHeightLimit = 0.55
var ruleRightTopEdgeIsInTopPartOfTheNumber = function () {
    if (n.rightTopEdge.y > numberHeight * rightTopEdgeHeightLimit) return false;
    return true;
}
var ruleRightTopEdgeIsInTopPartOfTheNumberFor8 = function () {
    if (n.rightTopEdge.y > numberHeight * rightTopEdgeHeightLimit * 0.80) return false;
    return true;
}
var topBottomWidthRatioLimit = 1.4
var ruleNumberTopAndBottomWidthsAreSame = function () {
    var topWidth = n.corners.roofRight.x - n.corners.roofLeft.x
    var bottomWidth = n.corners.floorRight.x - n.corners.floorLeft.x
    if (topWidth > topBottomWidthRatioLimit * bottomWidth) return false;
    if (bottomWidth > topBottomWidthRatioLimit * topWidth) return false;
    return true;
}
var ruleDeepLeftBottomRayDipExists = function () {
    if (n.leftBottomDip.size == 0) return false;
    if (n.leftBottomDip.rayY == 0) return false;
    return true;
}
var ruleDeepLeftTopRayDipExists = function () {
    if (n.leftTopDip.size == 0) return false;
    if (n.leftTopDip.rayY == 0) return false;
    return true;
}
var leftSideAlignmentLimitRatio = 0.4
var ruleLeftBottomLegIsVerticallyAlignedWithLeftTopOfTheNumber = function () {
    if (Math.abs(n.leftBottomEdge.x - n.leftTopEdge.x) > leftSideAlignmentLimitRatio * numberWidth) return false;
    if (n.leftTopEdge.x - n.leftBottomEdge.x > 2) return false;
    return true;
}
var ruleNoVerticalLongLines = function () {
    if (n.floorRadar.count > 1) return false;
    return true;
}
var topWidthLimitFor6WithSmallRightDip = 0.3
var ruleTopIsOkFor6WithSmallRightDip = function () {
    if (n.holes.length == 0) return false;
    if (Math.abs(n.roofRightEdge.x - n.rightTopEdge.x) > 3) return false;
    if (Math.abs(n.roofRightEdge.y - n.rightTopEdge.y) > 3) return false;
    if (Math.abs(n.roofLeftEdge.x - n.holes[0].xG) > 3) return false;
    if (Math.abs(n.roofLeftEdge.x - n.roofRightEdge.x) > topWidthLimitFor6WithSmallRightDip * numberWidth) return false;
    if (Math.abs(n.roofLeftEdge.y - n.roofRightEdge.y) > 0.5 * topWidthLimitFor6WithSmallRightDip * numberWidth) return false;
    return true;
}
var topWidthLimitFor9WithSmallRightDip = 0.3
var ruleBottomIsOkFor9WithSmallLeftDip = function () {
    if (n.holes.length == 0) return false;
    if (Math.abs(n.floorLeftEdge.x - n.leftBottomEdge.x) > 3) return false;
    if (Math.abs(n.floorLeftEdge.y - n.leftBottomEdge.y) > 3) return false;
    if (Math.abs(n.floorRightEdge.x - n.holes[0].xG) > 3) {
        if (Math.abs(n.floorRightEdge.x - n.holes[0].x) > 3) return false;
    }
    if (Math.abs(n.floorLeftEdge.x - n.floorRightEdge.x) > topWidthLimitFor9WithSmallRightDip * numberWidth) return false;
    if (Math.abs(n.floorLeftEdge.y - n.floorRightEdge.y) > 0.5 * topWidthLimitFor9WithSmallRightDip * numberWidth) return false;
    return true;
}
var rightDipVerticalDipPositionLimitFor3WithSmallTop = 0.40
var ruleRightDipIsAboveTheMidpoint = function () {
    if (n.rightDip.size == 0) return false;
    if (n.rightDip.yG > rightDipVerticalDipPositionLimitFor3WithSmallTop * numberHeight) return false;
    return true;
}
var noseFloorDipSizeLowLimitRatio = 0.02
var noseFloorDipSizeHighLimitRatio = 0.10
var ruleNoseHasFloorDip = function () {
    if (n.floorDip.size == 0) return false;
    if (n.floorDip.yG > numberHeight * 0.5) return false;
    if (n.floorDip.xG > 0.75 * numberWidth) return false;
    if (n.floorDip.xG < 0.25 * numberWidth) return false;
    if (n.floorDip.size < noseFloorDipSizeLowLimitRatio * nBoxSize) return false;
    if (n.floorDip.size > noseFloorDipSizeHighLimitRatio * nBoxSize) return false;
    return true;
}
var leftTopDipMinSizeLimitFor6WithLeftTopBoxRatio = 0.005
var leftTopDipMaxSizeLimitFor6WithLeftTopBoxRatio = 0.030
var leftTopDipYGLimitFor6WithLeftTopBoxRatio = 0.25
var ruleValidLeftTopDipFor6WithLeftTopBox = function () {
    if (n.leftTopDip.size < leftTopDipMinSizeLimitFor6WithLeftTopBoxRatio * nBoxSize) return true;
    if (n.leftTopDip.yG > leftTopDipYGLimitFor6WithLeftTopBoxRatio * numberHeight) return false;
    if (n.leftTopDip.size > leftTopDipMaxSizeLimitFor6WithLeftTopBoxRatio * nBoxSize) return false;
    return true;
}
var roofRightEdgeMaxDistanceRatioLimit = 0.20
var ruleRoofRightEdgeIsInTopRightCornerFor4withNoRightBulge = function () {
    if (numberWidth - n.roofRightEdge.x > roofRightEdgeMaxDistanceRatioLimit * numberWidth) return false;
    return true;
}
var ruleRoofRightEdgeIsInTopRightCornerFor9 = function () {
    if (n.roofRightEdge.x < 0.5 * numberWidth) return false;
    if (n.roofRightEdge.y > 0.2 * numberHeight) return false;
    return true;
}
var ruleRightTopDipRayIsWideEnough = function () {
    if (n.rightTopDip.size == 0) return false;
    if (n.rightTopDip.rayY == 0) return false;
    if (n.rightTopDip.rayY == n.rightTopDip.rayYTop) return false;
    return true;
}
var floorLeftXMaxRatio = 0.16
var floorLeftYMinRatio = 0.40
var floorLeftYMaxRatio = 0.7
var leftBottomXMinRatio = 0.28
var leftBottomXMaxRatio = 0.53
var leftBottomYMaxRatio = 0.13
var ruleFloorLeftEdgeInMidLeft = function () {
    if (n.leftBottomDip.size == 0) return false;
    if (n.leftBottomDip.rayY == 0) return false;
    if (n.leftBottomDip.rayY > floorLeftYMaxRatio * numberHeight) return false;
    if (n.leftTopDip.size != 0 && n.leftTopDip.rayYTop != 0 && n.leftTopDip.rayYTop < floorLeftYMinRatio * numberHeight) return false;
    return true;
}
var ruleLeftBottomEdgeInBottomMid = function () {
    if (n.leftBottomEdge.x < leftBottomXMinRatio * numberWidth || n.leftBottomEdge.x > leftBottomXMaxRatio * numberWidth) return false;
    if (numberHeight - n.leftBottomEdge.y > leftBottomYMaxRatio * numberHeight) return false;
    return true;
}
var minLeftBottomDipOpeningRatio = 0.034
var ruleLeftBottomDipOpeningIsWide = function () {
    if (n.leftBottomDip.size == 0) return false;
    if (n.leftBottomDip.rayY == 0) return false;
    if (n.leftBottomDip.rayYBottom - n.leftBottomDip.rayY < minLeftBottomDipOpeningRatio * numberHeight) return false;
    return true;
}
var floorMinWidthFor2Ratio = 0.75
var ruleFloorIsWideEnoughFor2 = function () {
    if (n.rightBottomEdge.x - n.leftBottomEdge.x < floorMinWidthFor2Ratio * numberWidth) return false;
    return true;
}
var floorMinWidthFor5Ratio = 0.65
var ruleFloorIsWideEnoughFor5 = function () {
    if (n.rightBottomEdge.x - n.leftBottomEdge.x < floorMinWidthFor5Ratio * numberWidth) return false;
    return true;
}
var ruleNormalTopEdges = function () {
    var midpoint = 0.5 * (n.roofRightEdge.x + n.roofLeftEdge.x)
    if (midpoint < 0.25 * numberWidth) return false;
    if (midpoint > 0.75 * numberWidth) return false;
    return true;
}
var ruleFloorDipIsBelowHole = function () {
    if (n.holes.length == 0) return false;
    if (n.holes[0].y + n.holes[0].height >= n.floorDip.y) return false;
    return true;
}
var leftDipRightSideDipVerticalPositionLimit = 0.65
var leftDipRightSideDipWidthToHeightRatioLimitRatio = 2
var ruleLeftDipRightSideDipIsSquareAndInTheMiddle = function () {
    if (n.leftDipRightSideDip.size == 0) return false;
    if (n.leftDipRightSideDip.width * n.leftDipRightSideDip.width > leftDipRightSideDipWidthToHeightRatioLimitRatio * n.leftDipRightSideDip.size) return false;
    if (n.leftDipRightSideDip.y + 0.5 * n.leftDipRightSideDip.height > leftDipRightSideDipVerticalPositionLimit * numberHeight) return false;
    return true;
}
var ruleLeftDipRayYExists = function () {
    if (n.leftTopDip.rayY == 0) return false;
    if (n.leftBottomDip.rayY == 0) return false;
    if (n.leftTopDip.rayYTop > n.leftDipRightSideDip.y) return false;
    if (n.leftBottomDip.rayYBottom < n.leftDipRightSideDip.y + ruleLargeLeftDipRightSideDip.height) return false;
    return true;
}
var ruleLeftDipIsBelowHole = function () {
    if (n.holes.length == 0) return false;
    if (n.leftBottomDip.x + n.leftBottomDip.width < n.holes[0].x + n.holes[0].width) return false;
    return true;
}
var leftBottomDipMinOpeningLimitRatio = 0.10
var ruleLeftBottomDipIsWideOpen = function () {
    if (n.leftBottomDip.size == 0) return false;
    if (n.leftBottomDip.rayYBottom == 0) return false;
    if (n.leftBottomDip.rayY == 0) return false;
    var limit = leftBottomDipMinOpeningLimitRatio * numberHeight
    if (limit > 3) limit = 3
    if (n.leftBottomDip.rayYBottom - n.leftBottomDip.rayY < limit) return false
    return true;
}
var rightTopDipMinOpeningLimitRatio = 0.07
var ruleRightTopDipIsWideOpen = function () {
    if (n.rightTopDip.size == 0) return false;
    if (n.rightTopDip.rayYTop == 0) return false;
    if (n.rightTopDip.rayY == 0) return false;
    var limit = rightTopDipMinOpeningLimitRatio * numberHeight
    if (limit > 2) limit = 2
    if (n.rightTopDip.rayY - n.rightTopDip.rayYTop < limit) return false
    return true;
}
var leftAndRightFloorAlignmentLimitRatio = 0.08
var ruleLeftAndRightFloorAreHorisontallyAligned = function () {
    if (Math.abs(n.floorLeftEdge.y - n.floorRightEdge.y) > leftAndRightFloorAlignmentLimitRatio * numberHeight) return false;
    return true;
}
var rightDipWidthMaxLimitRatio = 0.12
var ruleRightDipIsValidFor8 = function () {
    if (n.rightDip.size == 0) return true;
    if (n.rightDip.width > rightDipWidthMaxLimitRatio * numberWidth) return false;
    return true;
}
var ruleLeftDipIsValidFor8 = function () {
    if (n.leftDip.size == 0) return true;
    if (n.leftDip.width > rightDipWidthMaxLimitRatio * numberWidth) return false;
    return true;
}
var ruleRightTopDipIsValidFor6 = function () {
    if (n.rightTopDip.size == 0) return false;
    if (n.rightTopDip.rayY == 0) return false;
    return true;
}
var topAndBottomEdgesAlignmentLimitRatio = 0.11
var ruleTopAndBottomEdgesAreAlignedOnBothSides = function () {
    var limit = topAndBottomEdgesAlignmentLimitRatio * numberWidth
    if (limit < 2) limit = 2
    if (n.rightBottomEdge.x - n.rightTopEdge.x > limit) return false;
    if (n.leftTopEdge.x - n.leftBottomEdge.x > limit) return false;
    return true;
}
var floorEdgeHorisontalAlignmentLimitRatio = 0.1
var ruleFloorEdgesAreHorisontallyAligned = function () {
    var limit = floorEdgeHorisontalAlignmentLimitRatio * numberHeight
    if (limit < 2) limit = 2
    if (Math.abs(n.floorLeftEdge.y - n.floorRightEdge.y) > limit) return false;
    return true;
}
var topRightCornerSharpnessLimitRatio = 0.02
var ruleTopRightCornerIsSharp = function () {
    var dx = n.roofRightEdge.x - n.rightTopEdge.x
    var dy = n.roofRightEdge.y - n.rightTopEdge.y
    if ((dx * dx + dy * dy) > topRightCornerSharpnessLimitRatio * numberWidth * numberWidth) return false;
    return true;
}
var rightTopDipWidthToHeightLimitFor6Sharp = 0.7
var ruleTopRightCornerIsSharpFor6 = function () {
    if (n.rightTopDip.size == 0) return false;
    if (n.rightTopDip.width < rightTopDipWidthToHeightLimitFor6Sharp * n.rightTopDip.height) return false;
    var dx = n.roofRightEdge.x - n.rightTopEdge.x
    var dy = n.roofRightEdge.y - n.rightTopEdge.y
    if ((dx * dx + dy * dy) > topRightCornerSharpnessLimitRatio * numberWidth * numberWidth) return false;
    return true;
}
var widthToHeightRatioFor7 = 0.4
var ruleNumberWidthToHeightIsRightFor7 = function () {
    if (numberWidth < widthToHeightRatioFor7 * numberHeight) return false;
    return true;
}
var widthToHeightRatioFor3 = 0.4
var ruleNumberWidthToHeightIsRightFor3 = function () {
    if (numberWidth < widthToHeightRatioFor3 * numberHeight) return false;
    return true;
}
var widthToHeightRatioFor3Narrow = 0.40
var ruleNumberWidthToHeightIsRightFor3Narrow = function () {
    if (numberWidth < widthToHeightRatioFor3Narrow * numberHeight) return false;
    return true;
}


var dipHoleHeightRatio = 1.5
var ruleHoleHeightIsNotMuchLargerThanDipHeight = function () {
    if (n.leftBottomDip.size == 0) return false;
    if (n.holes.length == 0) return false;
    if (n.holes[0].height > dipHoleHeightRatio * n.leftBottomDip.height) return false;
    return true;
}
var ruleLeftTopIsLeftMost = function () {
    if (n.leftTopEdge.x > n.leftBottomEdge.x) return false;
    return true;
}
var holeCenterOfGravityOffsetLimit = 0.04
var ruleHoleIsValidFor9 = function () {
    if (n.holes.length == 0) return false;
    var hol = n.holes[0]
    if (hol.y < 2) return false;
    var count = 0
    if (hol.size > holeSizeLimit * nBoxSize) {
        if (hol.ovality > holeOvalityLimit) count++
        if (hol.xG - hol.x - 0.5 * hol.width > holeCenterOfGravityOffsetLimit * hol.width) count++
        if (hol.yG - hol.y - 0.5 * hol.height > holeCenterOfGravityOffsetLimit * hol.height) count++
    }
    if (count > 1) return false;
    return true;
}
var topRightEdgeRightLimitRatioFor6WithoutDip = 0.53
var topRightEdgeBottomLimitRatioFor6WithoutDip = 0.9
var rightTopEdgeTopLimitRatioFor6WithoutDip = 0.3
var rightTopEdgeRightLimitRatioFor6WithoutDip = 0.9
var ruleTopIsOkfor6WithoutTopDip = function () {
    if (n.roofRightEdge.x > topRightEdgeRightLimitRatioFor6WithoutDip * numberWidth) return false;
    if (n.roofRightEdge.y > topRightEdgeBottomLimitRatioFor6WithoutDip * numberHeight) return false;
    if (n.rightTopEdge.y < rightTopEdgeTopLimitRatioFor6WithoutDip * numberHeight) return false;
    if (n.rightTopEdge.x < rightTopEdgeRightLimitRatioFor6WithoutDip * numberWidth) return false;
    return true;
}
var ruleRightSideHasLongStraightLine = function () {
    if (n.roofRadar.rightSideRay < 0.5 * numberHeight) return false;
    return true;
}
var trueRulesFor0 = [ruleHoleIsNarrowOvale, ruleFullNumberVisibleFor0, ruleOneLargeHoleInCenter, ruleNoLeftDip, ruleNoFloorDip, ruleNormalTopEdges,
    ruleMinimalRightDip, ruleNoRoofDip, ruleHoleIsVeryHighFor0, ruleRadarsIndicateZero];
var falseRulesFor0 = [ruleTwoAboutSameSizeHoles, ruleHoleHasDips, ruleNumberIsHigherThanMaxNumberHeight,
    ruleNumberIsTooNarrow, ruleNumberExtendsToRoofLeftCorner]

var trueRulesFor1WithNose = [ruleFullNumberVisible, ruleNoFloorDip, ruleNumberWidthIsSmallComparedToHeight,
    ruleNoLeftDip, ruleNoWideRightDip, ruleNoRoofDip, ruleFloorIsNarrowFor1, ruleOneIsUpRight, ruleNoseIsInTopPartOfNumber, ruleLongPartIsOnTheRight,
    ruleOneIsSquareBoxFor1WithNose];
var falseRulesFor1WithNose = [ruleHoles, ruleRightSideIsClearlyConcave, ruleNumberIsHigherThanMaxNumberHeight,
    ruleNumberIsTooNarrowFor1, ruleNumberOneSizeIsTooSmallForPlainOne];

var trueRulesFor1WithHangingNose = [ruleFullNumberVisible, ruleNoseHasFloorDip, ruleNumberWidthIsSmallComparedToHeight,
    ruleNoLeftDip, ruleNoWideRightDip, ruleNoRoofDip, ruleFloorIsNarrowFor1WithHangingNose, ruleOneIsUpRightFor1WithHangingNose, ruleNoseIsInTopPartOfNumber, ruleLongPartIsOnTheRight,
    ruleOneIsSquareBoxFor1WithHangingNose];
var falseRulesFor1WithHangingNose = [ruleHoles, ruleRightSideIsClearlyConcave, ruleNumberIsHigherThanMaxNumberHeight,
    ruleNumberIsTooNarrowFor1, ruleNumberOneSizeIsTooSmallForPlainOne];

var trueRulesFor1NoNose = [ruleFullNumberVisible, ruleNoFloorDip, ruleNumberWidthIsSmallComparedToHeight,
    ruleNoLeftDip, ruleNoWideRightDip, ruleNoRoofDip, ruleFloorIsNarrowFor1, ruleOneIsUpRight,
    ruleOneIsInTheMiddleOfThePage, ruleLongPartIsOnTheRight, ruleNumberIsLooseFromTopOfThePage, ruleOneIsSquareBoxFor1NoNose];
var falseRulesFor1NoNose = [ruleHoles, ruleRightSideIsClearlyConcave, ruleNumberIsHigherThanMaxNumberHeight,
    ruleNumberOneSizeIsTooSmallForPlainOne];

var trueRulesFor1WithTopTBar = [ruleFullNumberVisible, ruleNumberHasTopTBar, ruleOneIsInTheMiddle, ruleNoLeftDipFor1WithTopTBar, ruleNoRoofDip,
    ruleOneIsInTheMiddleOfThePage, ruleTBarOneIsHigh, ruleTBarAndOneCoverMostArea, ruleNoLargeRightDip];
var falseRulesFor1WithTopTBar = [ruleHoles, ruleNumberIsTooNarrowFor1, ruleNumberOneSizeIsTooSmall, ruleVerticalBarTiltsRightIn1WithTopBar];

var trueRulesFor1WithBottomTBar = [ruleFullNumberVisible, ruleNumberHasBottomTBar, ruleOneIsInTheMiddle,
    ruleOneIsInTheMiddleOfThePage, ruleTBarOneIsHigh, ruleTBarAndOneCoverMostArea, ruleNoLargeRightDip];
var falseRulesFor1WithBottomTBar = [ruleHoles, ruleNumberIsTooNarrowFor1, ruleNumberOneSizeIsTooSmall];

var trueRulesFor2 = [ruleFullNumberVisible, ruleTopBarBottomIsCurved, ruleLargeLeftDip, ruleLeftTopDipIsLarge, ruleTopAndBottomEdgesAreAlignedOnBothSides,
    ruleLargeRightDip, ruleRightBottomDipIsLarge, ruleNoFloorDip, ruleFloorIsWideEnoughFor2, ruleNoRoofDip,
    ruleleftEdgesAreVerticallyAligned, ruleNumberTopAndBottomWidthsAreSame, ruleDeepLeftTopRayDipExists];
var falseRulesFor2 = [ruleHoles, ruleNumberIsHigherThanMaxNumberHeight, ruleLeftTopDipHasConcaveBottom,
    ruleLargeLeftDipRightSideDip, ruleNumberExtendsToRoofLeftCorner,
    ruleLeftTopDipIsLargeComparedToTopRayDip, ruleRightBottomDipIsLargeComparedToBottomRayDip, ruleNumberIsTooNarrow];

var trueRulesFor3 = [ruleFullNumberVisible, ruleLargeLeftDipInMid, ruleNoRoofDip, ruleDiagonalBarIsCurved, ruleLeftDipRightSideDipIsSquareAndInTheMiddle,
    ruleLeftDipRayYExists, ruleNumberWidthToHeightIsRightFor3,
    ruleLargeLeftDipRightSideDip, ruleFloorRightCornerIn4, ruleLeftDipHeightIsLargerThanWidth, ruleMaxSmallRightDipInTheMiddle];
var falseRulesFor3 = [ruleHoles, ruleLeftTopDipIsLarge,
    ruleLeftTopRayDipIsLargeComparedToBottomFor3,
    ruleLeftBottomDipIsLarge, ruleLeftBottomRayDipIsLargeComparedToTop, ruleTopBarBottomCurveSizeIsExcessive,
    ruleNumberIsHigherThanMaxNumberHeight, ruleNumberIsTooNarrow, ruleNumberExtendsToRoofLeftCorner];

var trueRulesFor3Narrow = [ruleFullNumberVisible, ruleLargeLeftDipInMid, ruleNoRoofDip, ruleDiagonalBarIsCurved, ruleLeftDipRightSideDipIsSquareAndInTheMiddle,
    ruleLeftDipRayYExists, ruleNumberWidthToHeightIsRightFor3Narrow,
    ruleLargeLeftDipRightSideDipFor3Narrow, ruleFloorRightCornerIn4, ruleLeftDipHeightIsLargerThanWidth, ruleMaxSmallRightDipInTheMiddle];
var falseRulesFor3Narrow = [ruleHoles, ruleLeftTopDipIsLarge,
    ruleLeftTopRayDipIsLargeComparedToBottomFor3,
    ruleLeftBottomDipIsLarge, ruleLeftBottomRayDipIsLargeComparedToTop, ruleTopBarBottomCurveSizeIsExcessive,
    ruleNumberIsHigherThanMaxNumberHeight, ruleNumberIsTooNarrow];

var trueRulesFor3SmallTop = [ruleFullNumberVisible, ruleLargeLeftDipInMid, ruleNoRoofDip, ruleDiagonalBarIsCurved, ruleRightDipIsAboveTheMidpoint,
    ruleLeftDipRayYExists, ruleNumberWidthToHeightIsRightFor3,
    ruleLeftBottomRayDipIsLargeComparedToTopFor3WithSmallTop, ruleLeftDipRightSideDipIsSquareAndInTheMiddle,
    ruleLargeLeftDipRightSideDip, ruleFloorRightCornerIn4, ruleLeftDipHeightIsLargerThanWidth, ruleMaxSmallRightDipInTheMiddle];
var falseRulesFor3SmallTop = [ruleHoles, ruleLeftTopDipIsLarge,
    ruleLeftTopRayDipIsLargeComparedToBottomFor3,
    ruleLeftBottomDipIsLarge, ruleTopBarBottomCurveSizeIsExcessive,
    ruleNumberIsHigherThanMaxNumberHeight, ruleNumberIsTooNarrow, ruleNumberExtendsToRoofLeftCorner];

var trueRulesFor4 = [ruleFullNumberVisible, ruleSmallRightDip, ruleNoLeftDip, ruleNoFloorDip, ruleRightButtExists, ruleRadarsIndicate4WithDip,
    ruleLeftTopTiltsRight, ruleFloorLeftIsCurvedFor4, ruleHorisontalLineInTheBottomHalf, ruleBottomFeetExists, ruleRoofIsNarrowAndHorisontalFor4WithDip];
var falseRulesFor4 = [ruleHoles, ruleRightTopDipDiagonalIsCurvedFor4, ruleRoofLeftSideIsCurved,
    ruleNumberIsHigherThanMaxNumberHeight, ruleNumberIsTooNarrow];

var trueRulesFor4Narrow = [ruleFullNumberVisible, ruleSmallRightDip, ruleNoLeftDip, ruleNoFloorDip, ruleRightButtExists, ruleRadarsIndicate4WithDip,
    ruleLeftTopTiltsRightFor4Narrow, ruleFloorLeftIsCurvedFor4, ruleHorisontalLineInTheBottomHalf, ruleBottomFeetExists, ruleRoofIsNarrowAndHorisontalFor4WithDip];
var falseRulesFor4Narrow = [ruleHoles, ruleRightTopDipDiagonalIsCurvedFor4, ruleRoofLeftSideIsCurved,
    ruleNumberIsHigherThanMaxNumberHeight, ruleNumberIsTooNarrow];

var trueRulesFor4WithRoofDip = [ruleFullNumberVisible, ruleSmallRoofDip, ruleNoLeftDip, ruleNoFloorDip, ruleRightButtExists, ruleRadarsIndicate4WithDip,
    ruleLeftTopTiltsRight, ruleFloorLeftIsCurvedFor4, ruleHorisontalLineInTheBottomHalf, ruleBottomFeetExists, ruleRoofIsNarrowAndHorisontalFor4WithDip];
var falseRulesFor4WithRoofDip = [ruleHoles, ruleRightTopDipDiagonalIsCurvedFor4, ruleRoofLeftSideIsCurved, ruleNoRightDip,
    ruleNumberIsHigherThanMaxNumberHeight, ruleNumberIsTooNarrow];

var trueRulesFor4WithHole = [ruleFullNumberVisibleFor4WithHole, ruleNoLeftDip, ruleOneLargeHoleInCenterFor4WithHole,
    ruleLeftTopTiltsRight, ruleRightButtExists, ruleNoRightDip, ruleNoFloorDip, ruleRoofIsNarrowAndHorisontalFor4WithHole,
    ruleNoRoofDip, ruleHoleIsInTheMiddleOfTheNumber, ruleRadarsIndicate4WithHole, ruleBottomFeetExists];
var falseRulesFor4WithHole = [ruleRoofLeftSideIsCurved, ruleHoleIsRoundFor4, ruleHoleIsVeryHigh,
    ruleNumberIsHigherThanMaxNumberHeight, ruleHoleIsBigComparedToHeight, ruleNumberIsTooNarrow];

var trueRulesFor4WithSmallHole = [ruleFullNumberVisibleFor4WithHole, ruleNoLeftDip, ruleOneSmallHoleFor4WithSmallHole, ruleRightButtExists, ruleRadarsIndicate4WithHole,
    ruleNoFloorDip, ruleRoofIsNarrowAndHorisontalFor4WithHole, ruleLeftTopTiltsRight, ruleHoleIsInTheMiddleOfTheNumber, ruleNoLargeRightDip, ruleBottomFeetExists];
var falseRulesFor4WithSmallHole = [ruleHoleIsVeryHigh, ruleRoofLeftSideIsCurved, ruleNumberIsHigherThanMaxNumberHeight, ruleNumberIsTooNarrow];

var trueRulesFor4NoRightBulge = [ruleFullNumberVisibleFor4WithHole, ruleNoLeftDip, ruleOneLargeHoleInCenter, ruleRadarsIndicate4WithHoleButNoRightBulge,
    ruleNoFloorDip, ruleRoofIsNarrowAndHorisontalFor4WithHole, ruleLeftTopTiltsRight, ruleHoleIsInTheMiddleOfTheNumber, ruleNoLargeRightDip, ruleBottomFeetExistsButNoRightBulge,
    ruleRoofRightEdgeIsInTopRightCornerFor4withNoRightBulge];
var falseRulesFor4NoRightBulge = [ruleHoleIsVeryHigh, ruleRoofLeftSideIsCurved, ruleNumberIsHigherThanMaxNumberHeight, ruleNumberIsTooNarrow];


var trueRulesFor5 = [ruleFullNumberVisible, ruleLargeLeftDip, ruleLeftBottomDipIsLarge, ruleLargeRightDip, ruleFloorIsWideEnoughFor5,
    ruleLargeRightDip, ruleNoRoofDip, ruleDipsHaveEqualWidthFor5, ruleHorisontalTopBarFor5, ruleTopRightCornerIsSharp];
var falseRulesFor5 = [ruleHoles, ruleRightTopDipIsLargeComparedToTopRayDip, ruleLeftBottomDipIsLargeComparedToBottomRayDipFor5,
    ruleLeftBottomDipHasConcaveTopFor5, ruleRightTopDipHasConcaveTopFor5, ruleRightTopDipHasConcaveBottomFor6,
    ruleNumberIsHigherThanMaxNumberHeight, ruleNumberIsTooNarrow, ruleVerticalBarExists, ruleLargeLeftDipRightSideDip, ruleNumberExtendsToFloorLeftCorner];

var trueRulesFor5WithConcaveLeftBottomDipTop = [ruleFullNumberVisible, ruleLargeLeftDip, ruleLeftBottomDipIsLarge, ruleLargeRightDip, ruleFloorIsWideEnoughFor5,
    ruleLargeRightDip, ruleNoRoofDip, ruleDipsHaveEqualWidthFor5, ruleHorisontalTopBarFor5, ruleLeftBottomDipOpeningIsWide, ruleTopRightCornerIsSharp];
var falseRulesFor5WithConcaveLeftBottomDipTop = [ruleHoles, ruleRightTopDipIsLargeComparedToTopRayDip, ruleLeftBottomDipIsLargeComparedToBottomRayDipFor5,
    ruleRightTopDipHasConcaveTopFor5, ruleRightTopDipHasConcaveBottomFor6,
    ruleNumberIsHigherThanMaxNumberHeight, ruleNumberIsTooNarrow, ruleVerticalBarExists, ruleLargeLeftDipRightSideDip];

var trueRulesFor5WithShortFeet = [ruleFullNumberVisible, ruleLargeLeftDip, ruleLeftBottomDipIsLarge, ruleLargeRightDip, ruleTopRightCornerIsSharp,
    ruleLargeRightDip, ruleNoRoofDip, ruleHorisontalTopBarFor5, ruleNumberExtendsNearRoofLeftCorner, ruleFloorLeftEdgeInMidLeft, ruleLeftBottomEdgeInBottomMid];
var falseRulesFor5WithShortFeet = [ruleHoles, ruleRightTopDipIsLargeComparedToTopRayDip, ruleLeftBottomDipIsLargeComparedToBottomRayDipFor5,
    ruleLeftBottomDipHasConcaveTopFor5, ruleRightTopDipHasConcaveTopFor5,
    ruleNumberIsHigherThanMaxNumberHeight, ruleNumberIsTooNarrow, ruleVerticalBarExists, ruleLargeLeftDipRightSideDip, ruleNumberExtendsToFloorLeftCorner];

var trueRulesFor5ExtendsToFloorLeft = [ruleFullNumberVisible, ruleLargeLeftDip, ruleLeftBottomDipIsLarge, ruleLargeRightDip, ruleFloorIsWideEnoughFor5,
    ruleLargeRightDip, ruleNoRoofDip, ruleDipsHaveEqualWidthFor5, ruleHorisontalTopBarFor5];
var falseRulesFor5ExtendsToFloorLeft = [ruleHoles, ruleRightTopDipIsLargeComparedToTopRayDip, ruleLeftBottomDipIsLargeComparedToBottomRayDipFor5,
    ruleLeftBottomDipHasConcaveTopFor5, ruleRightTopDipHasConcaveTopFor5, ruleRightTopDipHasConcaveBottomFor6,
    ruleNumberIsHigherThanMaxNumberHeight, ruleNumberIsTooNarrow, ruleVerticalBarExists, ruleLargeLeftDipRightSideDip];


var trueRulesFor5Wide = [ruleFullNumberVisible, ruleLargeLeftDip, ruleLeftBottomDipIsLarge, ruleLargeRightDip, ruleFloorIsWideEnoughFor5,
    ruleLargeRightDip, ruleNoRoofDip, ruleDipsHaveEqualWidthFor5, ruleNarrowHorisontalTopBarFor5];
var falseRulesFor5Wide = [ruleHoles, ruleRightTopDipIsLargeComparedToTopRayDip, ruleLeftBottomDipIsLargeComparedToBottomRayDipFor5,
    ruleLeftBottomDipHasConcaveTopFor5, ruleRightTopDipHasConcaveTopFor5, ruleRightTopDipHasConcaveBottomFor6,
    ruleNumberIsHigherThanMaxNumberHeight, ruleNumberIsTooNarrow, ruleVerticalBarExists, ruleLargeLeftDipRightSideDip, ruleNumberExtendsToFloorLeftCorner];

var trueRulesFor6 = [ruleFullNumberVisible, ruleLargeRightDip, ruleRightTopDipIsLarge, ruleOneLargeHoleIn2, ruleNoRoofDip, ruleHoleIsNotVeryHigh, ruleNoLeftDipFor8, ruleRightTopDipIsValidFor6,
    ruleNoFloorDip, ruleNoLeftDipFor6, ruleNumberOvalityIsNormalFor6, ruleHoleIsWideComparedToNumberWidth, ruleMinimalRightBottomDip, ruleHoleIsRoundFor6];
var falseRulesFor6 = [ruleNumberIsHigherThanMaxNumberHeight, ruleRightTopDipIsLargeComparedToTopRayDipFor6, ruleRightTopDipHasConcaveBottomFor6,
    ruleNumberIsTooNarrow, ruleNumberExtendsToFloorLeftCorner, ruleTopRightCornerIsSharpFor6];

var trueRulesFor6WithSmallHole = [ruleFullNumberVisible, ruleLargeRightDip, ruleRightTopDipIsLarge, ruleOneLargeHoleIn2, ruleNoRoofDip, ruleHoleIsNotVeryHigh, ruleNoLeftDipFor8, ruleRightTopDipIsValidFor6,
    ruleNoFloorDip, ruleNoLeftDipFor6, ruleNumberOvalityIsNormalFor6, ruleHoleIsBelowDipFor6WithSmallHole, ruleMinimalRightBottomDip, ruleHoleIsRoundFor6];
var falseRulesFor6WithSmallHole = [ruleNumberIsHigherThanMaxNumberHeight, ruleRightTopDipIsLargeComparedToTopRayDipFor6, ruleRightTopDipHasConcaveBottomFor6,
    ruleNumberIsTooNarrow, ruleNumberExtendsToRoofRightCorner, ruleNumberExtendsToFloorLeftCorner, ruleTopRightCornerIsSharpFor6];

var trueRulesFor6WithLeftTopBox = [ruleFullNumberVisible, ruleLargeRightDip, ruleRightTopDipIsLarge, ruleOneLargeHoleIn2, ruleNoRoofDip, ruleHoleIsNotVeryHigh,
    ruleValidLeftTopDipFor6WithLeftTopBox, ruleRightTopDipIsValidFor6,
    ruleNoFloorDip, ruleNumberOvalityIsNormalFor6, ruleHoleIsWideComparedToNumberWidthFor6WithLeftTopBox, ruleMinimalRightBottomDip, ruleHoleIsRoundFor6];
var falseRulesFor6WithLeftTopBox = [ruleNumberIsHigherThanMaxNumberHeight, ruleRightTopDipIsLargeComparedToTopRayDipFor6, ruleRightTopDipHasConcaveBottomFor6,
    ruleNumberIsTooNarrow, ruleNumberExtendsToRoofRightCorner, ruleNumberExtendsToFloorLeftCorner, ruleTopRightCornerIsSharpFor6];

var trueRulesFor6WithSmallRightDip = [ruleFullNumberVisible, ruleSmallRightDip, ruleTopIsOkFor6WithSmallRightDip,
    ruleRightTopDipIsLarge, ruleOneLargeHoleIn2, ruleNoRoofDip, ruleHoleIsNotVeryHigh, ruleNoLeftDipFor8,
    ruleNoFloorDip, ruleNoLeftDipFor6, ruleNumberOvalityIsNormalFor6, ruleHoleIsWideComparedToNumberWidth, ruleMinimalRightBottomDip, ruleHoleIsRoundFor6];
var falseRulesFor6WithSmallRightDip = [ruleNumberIsHigherThanMaxNumberHeight, ruleRightTopDipIsLargeComparedToTopRayDipFor6, ruleRightTopDipHasConcaveBottomFor6,
    ruleNumberIsTooNarrow, ruleNumberExtendsToRoofRightCorner, ruleNumberExtendsToFloorLeftCorner];

var trueRulesFor6WithoutTopDip = [ruleFullNumberVisible, ruleMinimalRightDip, ruleTopIsOkfor6WithoutTopDip, ruleradarsIndicate6WithoutTopDip,
    ruleOneLargeHoleIn2, ruleNoRoofDip, ruleHoleIsNotVeryHigh, ruleNoLeftDipFor8,
    ruleNoFloorDip, ruleNoLeftDipFor6, ruleNumberOvalityIsNormalFor6, ruleHoleIsRoundFor6];
var falseRulesFor6WithoutTopDip = [ruleNumberIsHigherThanMaxNumberHeight,
    ruleNumberExtendsToRoofRightCorner, ruleNumberExtendsToFloorLeftCorner, ruleNumberExtendsToRoofRightCorner];

var trueRulesFor6WithRightBottomDip = [ruleFullNumberVisible, ruleLargeRightTopDip, ruleLargeRightBottomDip,
    ruleRightBottomRayDipIsLargeFor6, ruleRightBottomDipIsLargeComparedToBottomRayDip, ruleNoLeftDip,
    ruleNoRoofDip, ruleNoFloorDip, ruleroofTopIsConvex, ruleNumberOvalityIsNormalFor6, ruleRightTopDipRayIsWideEnough];
var falseRulesFor6WithRightBottomDip = [ruleHoles, ruleNumberIsHigherThanMaxNumberHeight, rulerightDipIsHigh, ruleNumberIsTooNarrow];

var trueRulesFor6WithLeftBottomDip = [ruleFullNumberVisible, ruleLargeRightTopDip, ruleLeftBottomDipIsLarge,
    ruleLeftBottomDipIsLargeComparedToBottomRayDipFor6, ruleNoRoofDip, ruleNoFloorDip,
    ruleroofTopIsConvex, ruleNumberOvalityIsNormalFor6, ruleRightTopDipRayIsWideEnough];
var falseRulesFor6WithLeftBottomDip = [ruleHoles, ruleNumberIsHigherThanMaxNumberHeight, ruleNumberIsTooNarrow, ruleTopRightCornerIsSharpFor6];

var trueRulesFor6WithFloorDip = [ruleNumberIsInBottomHalfOfThePage, ruleFullNumberVisibleFor4WithHole,
    ruleFullNumberVisible, ruleLargeRightTopDip, ruleNoLeftDip, ruleNoRoofDip, ruleLargeFloorDip, ruleLeftAndRightFloorAreHorisontallyAligned,
    ruleFloorDipEgdesAreSymmetric, ruleMinimalRightBottomDip, ruleDipIsIntheMiddleOfTheNumber, ruleRightTopDipRayIsWideEnough];

var falseRulesFor6WithFloorDip = [ruleHoles, ruleNumberIsHigherThanMaxNumberHeight, ruleNumberIsTooNarrow, ruleTopRightCornerIsSharpFor6,
    ruleFloorDipIsVeryHigh];

var trueRulesFor7 = [ruleFullNumberVisible, ruleLargeLeftDip, ruleLeftDipIsHigh, ruleNoRightDipFor7, ruleFloorIsNarrowFor7, ruleNumberWidthToHeightIsRightFor7,
    ruleRightBottomTiltsRight, ruleNumberSevenHasTopBar, ruleNumberIsNotTooWideComparedToHeight, ruleBottomLeftCornerIsValid, ruleLeftTopIsLeftMost, ruleRadarsIndicate7];
var falseRulesFor7 = [ruleHoles, ruleDiagonalBarIsCurvedFor7, ruleRoofLeftSideIsCurved, ruleroofTopIsConvex,
    ruleNumberIsHigherThanMaxNumberHeight, ruleRightBottomIsClearlyConvex, ruleNumberIsTooNarrow];

var trueRulesFor7Wide = [ruleFullNumberVisible, ruleLargeLeftDip, ruleLeftDipIsHigh, ruleNoRightDipFor7, ruleFloorIsNarrowFor7, ruleNoVerticalLongLines, ruleLeftTopIsLeftMost,
    ruleRightBottomTiltsRight, ruleNumberSevenHasTopBar, ruleNumberIsNotTooWideComparedToHeightFor7Wide, ruleBottomLeftCornerAndTopLeftCornerIsValidFor7Wide, ruleRadarsIndicate7];
var falseRulesFor7Wide = [ruleHoles, ruleDiagonalBarIsCurvedFor7, ruleRoofLeftSideIsCurved, ruleroofTopIsConvex,
    ruleNumberIsHigherThanMaxNumberHeight, ruleRightBottomIsClearlyConvex, ruleNumberIsTooNarrow];

var trueRulesFor8 = [ruleFullNumberVisible, ruleTwoAboutSameSizeHoles, ruleTopHoleIsSmallerThanBottomHole, ruleNumberIsBottomHeavyForEight, ruleTopHoleIsRound,
    ruleBottomHoleIsRound, ruleRightDipIsValidFor8]
var falseRulesFor8 = [ruleNumberIsHigherThanMaxNumberHeight, ruleNumberIsTooNarrow];

var trueRulesFor8WithBiggerTopHole = [ruleFullNumberVisible, ruleTwoAboutSameSizeHoles, ruleNumberIsBottomHeavyForEight, ruleTopHoleIsRound,
    ruleBottomHoleIsRound, ruleRightDipIsValidFor8, ruleLeftDipIsValidFor8]
var falseRulesFor8WithBiggerTopHole = [ruleNumberIsHigherThanMaxNumberHeight, ruleNumberIsTooNarrow];

var trueRulesFor8WithSmallLeftDip = [ruleFullNumberVisible, ruleLeftBottomLegIn3, ruleOneLargeHoleIn1, ruleSmallLeftBottomDip, ruleNoRoofDip, ruleHoleIsNotVeryHigh,
    ruleNoFloorDip, ruleOnlyOneHole, ruleHoleIsBigEnoughComparedToLeftBottomDip, ruleLeftDipIsBelowHole, ruleHoleHeightIsNotMuchLargerThanDipHeight,
    ruleDeepLeftBottomRayDipExists, ruleNoLargeRightBottomRayDip, ruleLeftBottomDipHasConcaveTopFor8];
var falseRulesFor8WithSmallLeftDip = [ruleLeftBottomDipIsLargeComparedToBottomRayDipFor9, ruleNumberIsHigherThanMaxNumberHeight, ruleLeftBottomDipIsWideOpen,
    ruleNumberIsTooNarrow, ruleNumberExtendsToFloorRightCorner, ruleNumberExtendsToRoofRightCorner, ruleRightSideHasLongStraightLine];

var trueRulesFor8WithOneBigHole = [ruleFullNumberVisible, ruleOneLargeHoleInCenter, ruleHoleIsVeryHigh,
    ruleHoleHasDipsOnBothSides];
var falseRulesFor8WithOneBigHole = [ruleNumberIsHigherThanMaxNumberHeight, ruleNumberIsTooNarrow, ruleNoSideDipsFor8];

var trueRulesFor8WithFloorDip = [ruleNumberIsInBottomHalfOfThePage, ruleOneLargeHoleIn1, ruleDipIsIntheMiddleOfTheNumber, ruleFloorDipIsBelowHole,
    ruleLargeFloorDip, ruleNoLeftDip, ruleNoRightDip, ruleNoRoofDip, ruleFloorDipAndHoleAreOnTopOfEachOtherAndWidthAndHeightAreaEqual, ruleTopHoleIsRoundFor8WithBottomDip];
var falseRulesFor8WithFloorDip = [ruleNumberIsHigherThanMaxNumberHeight, ruleNumberIsTooNarrow, ruleHoleHeightIsBiggerThanWidth];

var trueRulesFor8WithTopLeftDip = [ruleOneLargeHoleIn2, ruleNoRoofDip, ruleNoFloorDip, ruleLeftTopDipIsLarge,
    ruleLeftTopDipAndHoleAreOnTopOfEachOtherAndWidthIsEqual, ruleBottomHoleIsRoundFor8WithTopDip, ruleLeftTopDipHasConcaveBottom];
var falseRulesFor8WithTopLeftDip = [ruleNumberIsHigherThanMaxNumberHeight, ruleNumberIsTooNarrow, ruleHoleHeightIsBiggerThanWidth];

var trueRulesFor8WithTopRightDip = [ruleOneLargeHoleIn2, ruleNoRoofDip, ruleNoFloorDip, ruleRightTopDipIsLarge,
    ruleRightTopDipAndHoleAreOnTopOfEachOtherAndWidthIsEqual, ruleBottomHoleIsRoundFor8WithTopDip, ruleRightTopDipHasConcaveBottomFor8];
var falseRulesFor8WithTopRightDip = [ruleNumberIsHigherThanMaxNumberHeight, ruleNumberIsTooNarrow, ruleHoleHeightIsBiggerThanWidth, ruleRightTopDipIsWideOpen];

var trueRulesFor9WithBigLeftDip = [ruleFullNumberVisible, ruleLeftBottomLegIn3, ruleOneLargeHoleIn1, ruleLargeLeftDip, ruleNoRoofDip, ruleHoleIsNotVeryHigh, ruleRightTopEdgeIsInTopPartOfTheNumber,
    ruleLeftBottomDipIsLarge, ruleNoRightDipFor9, ruleNoFloorDip, ruleOnlyOneHole, ruleHoleIsBigEnoughComparedToLeftBottomDip, ruleRoofRightEdgeIsInTopRightCornerFor9,
    ruleDeepLeftBottomRayDipExists, ruleNoLargeRightBottomRayDip, ruleLeftBottomLegIsVerticallyAlignedWithLeftTopOfTheNumber, ruleRadarsIndicate9, ruleHoleIsValidFor9];
var falseRulesFor9WithBigLeftDip = [ruleLeftBottomDipIsLargeComparedToBottomRayDipFor9, ruleNumberIsHigherThanMaxNumberHeight,
    ruleNumberIsTooNarrow, ruleNumberExtendsToFloorRightCorner, ruleNumberExtendsToRoofRightCorner, ruleLeftBottomDipHasConcaveTopFor9];

var trueRulesFor9WithSmallLeftDip = [ruleFullNumberVisible, ruleLeftBottomLegIn3, ruleOneLargeHoleIn1, ruleSmallLeftBottomDip, ruleNoRoofDip, ruleHoleIsNotVeryHigh, ruleRightTopEdgeIsInTopPartOfTheNumber,
    ruleNoRightDipFor9, ruleNoFloorDip, ruleOnlyOneHole, ruleHoleIsBigEnoughComparedToLeftBottomDip, ruleBottomIsOkFor9WithSmallLeftDip, ruleRoofRightEdgeIsInTopRightCornerFor9,
    ruleNoLargeRightBottomRayDip, ruleLeftBottomLegIsVerticallyAlignedWithLeftTopOfTheNumber, ruleRadarsIndicate9, ruleHoleIsValidFor9];
var falseRulesFor9WithSmallLeftDip = [ruleLeftBottomDipIsLargeComparedToBottomRayDipFor9, ruleNumberIsHigherThanMaxNumberHeight,
    ruleNumberIsTooNarrow, ruleNumberExtendsToFloorRightCorner, ruleNumberExtendsToRoofRightCorner, ruleLeftBottomDipHasConcaveTopFor9];


var trueTopRulesFor0_1 = [ruleTrueTest]
var falseTopRulesFor0_1 = [ruleFalseTest]
var trueBottomRulesFor0_1 = [ruleTrueTest]
var falseBottomRulesFor0_1 = [ruleTrueTest]




var intermediateTrueTopRuleLists = [trueTopRulesFor0_1]
var intermediateFalseTopRuleLists = [falseTopRulesFor0_1]
var intermediateTrueBottomRuleLists = [trueBottomRulesFor0_1]
var intermediateFalseBottomRuleLists = [falseBottomRulesFor0_1]
var intermediateNumberRuleLists = [intermediateTrueTopRuleLists, intermediateFalseTopRuleLists, intermediateTrueBottomRuleLists, intermediateFalseBottomRuleLists]
var intermediateRelatedDigits = [0]
var intermediateRelatedDigitNames = ['0_1']

var trueRuleLists = [trueRulesFor0, trueRulesFor1WithNose, trueRulesFor2, trueRulesFor3, trueRulesFor4,
    trueRulesFor5, trueRulesFor6, trueRulesFor7, trueRulesFor8, trueRulesFor9WithSmallLeftDip, trueRulesFor4WithHole,
    trueRulesFor8WithFloorDip, trueRulesFor8WithOneBigHole, trueRulesFor4WithRoofDip, trueRulesFor4WithSmallHole,
    trueRulesFor6WithRightBottomDip, trueRulesFor6WithFloorDip, trueRulesFor6WithLeftBottomDip,
    trueRulesFor1WithTopTBar, trueRulesFor1WithBottomTBar, trueRulesFor1NoNose, trueRulesFor9WithBigLeftDip, trueRulesFor8WithSmallLeftDip, trueRulesFor8WithTopLeftDip, trueRulesFor7Wide,
    trueRulesFor5Wide, trueRulesFor6WithSmallRightDip, trueRulesFor3SmallTop, trueRulesFor5ExtendsToFloorLeft, trueRulesFor4Narrow,
    trueRulesFor3Narrow, trueRulesFor6WithLeftTopBox, trueRulesFor1WithHangingNose, trueRulesFor6WithSmallHole, trueRulesFor4NoRightBulge,
    trueRulesFor5WithShortFeet, trueRulesFor5WithConcaveLeftBottomDipTop, trueRulesFor8WithTopRightDip, trueRulesFor6WithoutTopDip, trueRulesFor8WithBiggerTopHole]

var falseRuleLists = [falseRulesFor0, falseRulesFor1WithNose, falseRulesFor2, falseRulesFor3, falseRulesFor4,
    falseRulesFor5, falseRulesFor6, falseRulesFor7, falseRulesFor8, falseRulesFor9WithSmallLeftDip, falseRulesFor4WithHole,
    falseRulesFor8WithFloorDip, falseRulesFor8WithOneBigHole, falseRulesFor4WithRoofDip, falseRulesFor4WithSmallHole,
    falseRulesFor6WithRightBottomDip, falseRulesFor6WithFloorDip, falseRulesFor6WithLeftBottomDip, falseRulesFor1WithTopTBar,
    falseRulesFor1WithBottomTBar, falseRulesFor1NoNose, falseRulesFor9WithBigLeftDip, falseRulesFor8WithSmallLeftDip,
    falseRulesFor8WithTopLeftDip, falseRulesFor7Wide, falseRulesFor5Wide, falseRulesFor6WithSmallRightDip, falseRulesFor3SmallTop, falseRulesFor5ExtendsToFloorLeft,
    falseRulesFor4Narrow, falseRulesFor3Narrow, falseRulesFor6WithLeftTopBox, falseRulesFor1WithHangingNose, falseRulesFor6WithSmallHole, falseRulesFor4NoRightBulge,
    falseRulesFor5WithShortFeet, falseRulesFor5WithConcaveLeftBottomDipTop, falseRulesFor8WithTopRightDip, falseRulesFor6WithoutTopDip, falseRulesFor8WithBiggerTopHole]

var wholeNumberRuleLists = [trueRuleLists, falseRuleLists]
var relatedDigits = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 4, 8, 8, 4, 4, 6, 6, 6, 1, 1, 1, 9, 8, 8, 7, 5, 6, 3, 5, 4, 3, 6, 1, 6, 4, 5, 5, 8, 6, 8]
var relatedDigitNames = ['0', '1 WithNose', '2', '3', '4',
    '5', '6', '7', '8', '9 WithSmallLeftDip', '4 WithHole',
    '8 WithFloorDip', '8 WithOneBigHole', '4 WithRoofDip', '4 WithSmallHole',
    '6 WithRightBottomDip', '6 WithFloorDip', '6 WithLeftBottomDip', '1 WithTopTBar', '1 WithBottomTBar', '1 NoNose', '9 WithBigLeftDip', '8 WithSmallLeftDip', '8 WithTopLeftDip', '7 Wide',
    '5 Wide', '6 WithSmallRightDip', '3 SmallTop', '5 ExtendsToFloorLeft', '4 Narrow', '3 Narrow', '6 WithLeftTopBox', '1 WithHangingNose', '6 WithSmallHole',
    '4 NoRightBulge', '5 WithShortFeet', '5 WithConcaveLeftBottomDipTop', '8 WithTopRightDip', '6 WithoutTopDip', '8 WithBiggerTopHole']

function determineNumberDebug(numberD, bandConf) {
    d.debug('')
    d.debug('numberMaxWidth= ' + bandConf.numberMaxWidth + ' numberMaxHeight=' + bandConf.numberMaxHeight)
    var ruleResults = [];
    var functionResults = []
    var numberOfNumbers = 0
    numberOfNumbers = trueRuleLists.length
    var ruleLists = wholeNumberRuleLists
    for (var rule = 0; rule < numberOfNumbers; rule++) {
        ruleResults[rule] = 0
        for (var r = 0; r < ruleLists.length; r++) {
            var count = 0;
            var ruleCount = ruleLists[r][rule].length
            functionResults = []
            for (var i = 0; i < ruleCount; i++) {
                var result = ruleLists[r][rule][i](numberD, bandConf);
                if (r == 1 || r == 3) result = !result
                if (result == true) {
                    count++
                    functionResults.push(1)
                } else functionResults.push(0)
            }
            var trueFalseText = 'true  '
            if (r == 1 || r == 3) trueFalseText = 'false '
            d.debug(trueFalseText + d.addLeadingSpaces(relatedDigitNames[rule], 20) + '=' + JSON.stringify(functionResults))
            ruleResults[rule] += ruleCount - count
        }
    }
    var numberList = []
    var indexList = []
    var indexNameList = []
    for (var rule = 0; rule < numberOfNumbers; rule++) {
        if (ruleResults[rule] == 0) {
            numberList.push(relatedDigits[rule])
            indexNameList.push(relatedDigitNames[rule])
            indexList.push(rule)
        }
    }
    d.debug('indexes=' + JSON.stringify(indexList) + ' number= ' + indexNameList[0])
    d.debug('')
    return { 'numberList': numberList, 'indexList': indexList }
}
//globals 
var nBoxSize = null
var numberHeight = null
var numberWidth = null
var nD = null
var conf = null
var n = null
//end globals

function determineNumber(numberD, bandConf) {
    if (numberD.number.height == 0) return { 'numberList': [], 'indexList': [] }
    //globals 
    nD = numberD
    numberHeight = nD.number.height
    numberWidth = nD.number.width
    nBoxSize = numberHeight * numberWidth
    conf = bandConf
    n = numberD
    //end globals

    if (d.readDebugFlag() != 0) return determineNumberDebug(numberD, bandConf)
    var rule = 0
    rule = trueRuleLists.length
    var nmbr = -1
    var result = false;
    while (rule > 0 && result == false) {
        rule--;
        nmbr++;
        result = true
        var i = trueRuleLists[nmbr].length;
        while (i > 0 && result == true) result = trueRuleLists[nmbr][--i]();
        i = falseRuleLists[nmbr].length
        while (i > 0 && result == true) result = !falseRuleLists[nmbr][--i]();
    }
    if (result == true) return { 'numberList': [relatedDigits[nmbr]], 'indexList': [nmbr] }
    else return { 'numberList': [], 'indexList': [] }
}


function determineFirstDecimal(numberD, bandConf) {
    if (numberD.number.height == 0) return null
    return Math.round(100 * (0.5 * numberD.pageHeight - (numberD.number.y + numberD.number.oY + 0.5 * numberD.number.height)) / numberD.pageHeight)
}

function visualizeNumberAnalysis(numberD) {
    var page = []
    if (!numberD) {
        console.log('no numberData')
        return page;
    }
    var pageHeight = numberD.pageHeight
    var width = numberD.pageWidth
    for (var i = 0; i < pageHeight * width; i++)page[i] = 255;
    var numberHeight = numberD.number.height
    var numberWidth = numberD.number.width
    var numberOriginX = numberD.number.x
    var numberOriginY = numberD.number.y
    for (var y = numberOriginY; y < numberOriginY + numberHeight; y++) {
        for (var x = numberOriginX; x < numberOriginX + numberWidth; x++)page[x + y * width] = 128
    }
    for (var y = numberD.leftTopEdge.y; y < numberD.leftTopEdge.y + 3; y++) {
        for (var x = numberD.leftTopEdge.x; x < numberD.leftTopEdge.x + 3; x++)page[x + y * width] = 64
    }
    for (var y = numberD.rightTopEdge.y; y < numberD.rightTopEdge.y + 3; y++) {
        for (var x = numberD.rightTopEdge.x; x >= numberD.rightTopEdge.x - 2; x--)page[x + y * width] = 63
    }
    for (var y = numberD.leftBottomEdge.y; y > numberD.leftBottomEdge.y - 3; y--) {
        for (var x = numberD.leftBottomEdge.x; x < numberD.leftBottomEdge.x + 3; x++)page[x + y * width] = 62
    }
    for (var y = numberD.rightBottomEdge.y; y > numberD.rightBottomEdge.y - 3; y--) {
        for (var x = numberD.rightBottomEdge.x; x >= numberD.rightBottomEdge.x - 2; x--)page[x + y * width] = 61
    }
    for (var y = numberD.leftDip.yG - (Math.sqrt(numberD.leftDip.size) / 2) | 0; y < numberD.leftDip.yG + (Math.sqrt(numberD.leftDip.size) / 2); y++) {
        for (var x = 0; x < Math.sqrt(numberD.leftDip.size); x++)page[x + y * width] = 1
    }
    for (var y = numberD.rightDip.yG - (Math.sqrt(numberD.rightDip.size) / 2) | 0; y < numberD.rightDip.yG + (Math.sqrt(numberD.rightDip.size) / 2); y++) {
        for (var x = width - 1; x >= width - 1 - Math.sqrt(numberD.rightDip.size); x--)page[x + y * width] = 2
    }
    for (var y = 0; y < (Math.sqrt(numberD.roofDip.size)); y++) {
        for (var x = numberD.roofDip.xG - ((Math.sqrt(numberD.roofDip.size) / 2) | 0); x < numberD.roofDip.xG + Math.sqrt(numberD.roofDip.size) / 2; x++)page[x + y * width] = 3
    }
    for (var y = pageHeight - 1; y > pageHeight - 1 - (Math.sqrt(numberD.floorDip.size)); y--) {
        for (var x = numberD.floorDip.xG - (Math.sqrt(numberD.floorDip.size) | 0); x < numberD.floorDip.xG + Math.sqrt(numberD.floorDip.size); x++)page[x + y * width] = 4
    }
    var areaNumber = 4
    for (var i = 0; i < numberD.holes.length; i++) {
        areaNumber++;
        for (var y = numberD.holes[i].yG - (Math.sqrt(numberD.holes[i].size) / 2) | 0; y < numberD.holes[i].yG + (Math.sqrt(numberD.holes[i].size) / 2); y++) {
            for (var x = numberD.holes[i].xG - (Math.sqrt(numberD.holes[i].size) / 2 | 0); x < numberD.holes[i].xG + (Math.sqrt(numberD.holes[i].size) / 2); x++)page[x + y * width] = areaNumber;
        }
    }
    return page
}
var statistics = []
var parameterNames = []

function clearNumberStatistics() {
    statistics = [];
    parameterNames = [];
}
function addToDB(index, name, value) {
    if (!value) return;
    var found = -1
    for (var i = 0; i < parameterNames.length; i++) {
        if (parameterNames[i] == name) found = i
    }
    if (found < 0) {
        found = parameterNames.length
        parameterNames.push(name);
        for (var i = 0; i < relatedDigitNames.length; i++) {
            if (!statistics[i]) statistics[i] = []
            statistics[i].push([])
        }
    }
    statistics[index][found].push(value)
}
function addInstance(index, n) {
    addToDB(index, 'number.height', n.number.height)
    addToDB(index, 'number.height', n.number.height)
        ;
}
var intensityResolution = 10
function calculateIntensityProfile(list) {
    var l = list.length;
    if (l == 0) return [];
    var intensityProfile = [];
    var profileMin = m.min(list);
    var profileMax = m.max(list);
    for (var i = 0; i < intensityResolution + 1; i++)intensityProfile.push(0);
    for (var i = 0; i < l; i++) {
        intensityProfile[(intensityResolution * ((list[i] - profileMin) / (profileMax - profileMin))) | 0]++;
    }
    return intensityProfile;
}
function writeStatistics(path) {
    f.deleteFile(path)
    console.log(path)
    for (var i = 0; i < statistics.length; i++) {
        for (var name = 0; name < statistics[i].length; name++) {
            var r = statistics[i][name]
            var profile = calculateIntensityProfile(r)
            if (r.length > 0) {
                var text = (i + ' ' + relatedDigitNames[i] + ' ' + name + ' ' +
                    parameterNames[name] + ' ' + m.min(r) + ' ' + m.max(r) + ' ' + m.sum(r) +
                    ' ' + JSON.stringify(profile))
                console.log(text)
                fs.writeFileSync(path, text)
            }
        }
    }
}
function indexToDigit(index) {
    return relatedDigits[index]
}
module.exports = {
    clearNumberStatistics: function () { return clearNumberStatistics() },
    writeStatistics: function (path) { return writeStatistics(path) },
    visualizeNumberAnalysis: function (numberData) { return visualizeNumberAnalysis(numberData) },
    determineNumber: function (numberData1, conf, numberData2) { return determineNumber(numberData1, conf, numberData2) },
    createSimulatedNumber: function (number, width) { return createSimulatedNumber(number, width) },
    determineFirstDecimal: function (numberData, conf) { return determineFirstDecimal(numberData, conf) },
    indexToDigit: function (index) { return indexToDigit(index) }

}


//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/digitreader2/numberRules.js
// module id = 830
// module chunks = 0